require('./runtime');
(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("./utils"), require("./svgicon"), require("./flexlayout"), require("./container"), require("./tooltip"), require("./flyout"), require("./toolbar"), require("./slideout"));
	else if(typeof define === 'function' && define.amd)
		define(["./utils", "./svgicon", "./flexlayout", "./container", "./tooltip", "./flyout", "./toolbar", "./slideout"], factory);
	else {
		var a = typeof exports === 'object' ? factory(require("./utils"), require("./svgicon"), require("./flexlayout"), require("./container"), require("./tooltip"), require("./flyout"), require("./toolbar"), require("./slideout")) : factory(root["./utils"], root["./svgicon"], root["./flexlayout"], root["./container"], root["./tooltip"], root["./flyout"], root["./toolbar"], root["./slideout"]);
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})(window, function(__WEBPACK_EXTERNAL_MODULE__4__, __WEBPACK_EXTERNAL_MODULE__13__, __WEBPACK_EXTERNAL_MODULE__16__, __WEBPACK_EXTERNAL_MODULE__18__, __WEBPACK_EXTERNAL_MODULE__21__, __WEBPACK_EXTERNAL_MODULE__28__, __WEBPACK_EXTERNAL_MODULE__31__, __WEBPACK_EXTERNAL_MODULE__88__) {
return (window["wpBaUiCarbonToolkit"] = window["wpBaUiCarbonToolkit"] || []).push([[59],{

/***/ 0:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/interopRequireDefault");

/***/ }),

/***/ 1:
/***/ (function(module, exports) {

module.exports = require("react");

/***/ }),

/***/ 10:
/***/ (function(module, exports) {

module.exports = require("style-loader/lib/addStyles");

/***/ }),

/***/ 11:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/assertThisInitialized");

/***/ }),

/***/ 122:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

var _interopRequireWildcard = __webpack_require__(2);

exports.__esModule = true;
exports["default"] = exports.TabItemDnD = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(7));

var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(11));

var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(8));

var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(5));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(6));

var _react = _interopRequireWildcard(__webpack_require__(1));

var _reactDom = __webpack_require__(14);

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _lodash = __webpack_require__(20);

var _utils = __webpack_require__(4);

var _svgicon = _interopRequireDefault(__webpack_require__(13));

var _tooltip = _interopRequireDefault(__webpack_require__(21));

var _close_ = _interopRequireDefault(__webpack_require__(39));

var _flyout = __webpack_require__(28);

var _toolbar = _interopRequireDefault(__webpack_require__(31));

var _reactDnd = __webpack_require__(26);

var _ItemTypes = _interopRequireDefault(__webpack_require__(123));

var _TabLabel = _interopRequireDefault(__webpack_require__(505));

__webpack_require__(56);

var _dec, _dec2, _class, _class2, _temp;

var tabSource = {
  beginDrag: function beginDrag(props) {
    props.isDraggingCallback(true);
    return {
      id: props.panelId,
      index: props.index
    };
  }
};
var tabTarget = {
  hover: function hover(props, monitor, component) {
    var dragIndex = monitor.getItem().index;
    var hoverIndex = props.index; // Don't replace items with themselves

    if (dragIndex === hoverIndex) {
      return;
    } // Determine rectangle on screen


    var hoverBoundingRect = (0, _reactDom.findDOMNode)(component).getBoundingClientRect();

    if (props.vertical) {
      var hoverMiddleY = (hoverBoundingRect.bottom - hoverBoundingRect.top) / 2; // Determine mouse position

      var clientOffset = monitor.getClientOffset(); // Get pixels to the top

      var hoverClientY = clientOffset.y - hoverBoundingRect.top; // Only perform the move when the mouse has crossed half of the items height
      // When dragging downwards, only move when the cursor is below 50%
      // When dragging upwards, only move when the cursor is above 50%
      // Dragging downwards

      if (dragIndex < hoverIndex && hoverClientY < hoverMiddleY) {
        return;
      } // Dragging upwards


      if (dragIndex > hoverIndex && hoverClientY > hoverMiddleY) {
        return;
      }
    } else {
      // Get horizontal middle
      var hoverMiddleX = (hoverBoundingRect.right - hoverBoundingRect.left) / 2; // Determine mouse position

      var _clientOffset = monitor.getClientOffset();

      if (_clientOffset === null) {
        return;
      } // Get pixels to the left


      var hoverClientX = _clientOffset.x - hoverBoundingRect.left; // Only perform the move when the mouse has crossed half of the items width
      // When dragging downwards, only move when the cursor is below 50%
      // When dragging upwards, only move when the cursor is above 50%
      // Dragging left

      if (dragIndex < hoverIndex && hoverClientX < hoverMiddleX) {
        component.handler.component.setState({
          dragDivider: 'left'
        });
        return;
      } // Dragging right


      if (dragIndex > hoverIndex && hoverClientX > hoverMiddleX) {
        component.handler.component.setState({
          dragDivider: 'right'
        });
        return;
      }
    } // Time to actually perform the action


    props.moveTab(dragIndex, hoverIndex, false, props.keyValue); // Note: we're mutating the monitor item here!
    // Generally it's better to avoid mutations,
    // but it's good here for the sake of performance
    // to avoid expensive index searches.

    monitor.getItem().index = hoverIndex;
  },
  drop: function drop(props, monitor) {
    props.isDraggingCallback(false); // perform moveTab but inform that the tab has been dropped

    var dragIndex = monitor.getItem().index;
    var hoverIndex = props.index;
    props.moveTab(dragIndex, hoverIndex, true, props.keyValue);
  }
};
var TabItemDnD = (_dec = (0, _reactDnd.DropTarget)(_ItemTypes["default"].TAB, tabTarget, function (connect, monitor) {
  return {
    connectDropTarget: connect.dropTarget(),
    isOver: monitor.isOver()
  };
}), _dec2 = (0, _reactDnd.DragSource)(_ItemTypes["default"].TAB, tabSource, function (connect, monitor) {
  return {
    connectDragSource: connect.dragSource(),
    isDragging: monitor.isDragging()
  };
}), _dec(_class = _dec2(_class = (_temp = _class2 = /*#__PURE__*/function (_Component) {
  (0, _inheritsLoose2["default"])(TabItemDnD, _Component);

  function TabItemDnD() {
    return _Component.apply(this, arguments) || this;
  }

  var _proto = TabItemDnD.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        connectDragSource = _this$props.connectDragSource,
        connectDropTarget = _this$props.connectDropTarget,
        other = (0, _objectWithoutPropertiesLoose2["default"])(_this$props, ["connectDragSource", "connectDropTarget"]);
    return connectDragSource(connectDropTarget( /*#__PURE__*/_react["default"].createElement("div", {
      className: "ba-common-tabList__itemDraggable"
    }, ' ', /*#__PURE__*/_react["default"].createElement(TabItem, other), ' ')));
  };

  return TabItemDnD;
}(_react.Component), (0, _defineProperty2["default"])(_class2, "propTypes", {
  connectDragSource: _propTypes["default"].func.isRequired,
  connectDropTarget: _propTypes["default"].func.isRequired
}), _temp)) || _class) || _class);
exports.TabItemDnD = TabItemDnD;

var TabItem = /*#__PURE__*/function (_Component2) {
  (0, _inheritsLoose2["default"])(TabItem, _Component2);

  function TabItem(props) {
    var _this;

    _this = _Component2.call(this, props) || this;
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onKeyPress", function (event) {
      if (event.which === 13
      /* Enter */
      ) {
          event.preventDefault();
          event.target.blur();
        }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onKeyDown", function (e) {
      var _this$props2 = _this.props,
          deleteHandler = _this$props2.deleteHandler,
          onDeletePrompt = _this$props2.onDeletePrompt;

      switch (e.keyCode) {
        // enter
        case 13:
          e.preventDefault();
          e.stopPropagation();
          _this.tabLabel && _this.tabLabel.focusOnLabel();

          if (_this.props.toolbar) {
            _this.onDoubleClickHandler();
          }

          break;
        // delete

        case 46:
          e.preventDefault();
          e.stopPropagation();

          if (_this.props.deleteable) {
            if (onDeletePrompt) {
              _this.deleteCallback();
            } else {
              deleteHandler && deleteHandler();
            }
          }

          break;
        // ctrl/cmd + ->

        case 39:
          if (e.ctrlKey || e.metaKey) {
            _this.handleTabIncrement(e, 1);
          }

          _this.closeToolbar();

          break;
        // ctrl/cmd + <-

        case 37:
          if (e.ctrlKey || e.metaKey) {
            _this.handleTabIncrement(e, -1);
          }

          _this.closeToolbar();

          break;

        default:
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onDoubleClickHandler", function () {
      _this.setState(function (state) {
        return {
          flyoutOpen: !state.flyoutOpen
        };
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "closeToolbar", function () {
      _this.setState({
        flyoutOpen: false
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "focusHandler", function (value) {
      _this.setState({
        editActive: value
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "themeHoverOn", function () {
      _this.setState({
        themeHover: true
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "themeHoverOff", function () {
      _this.setState({
        themeHover: false
      });
    });
    _this.state = {
      label: _this.props.label,
      flyoutOpen: false,
      editActive: false,
      themeHover: false
    };
    return _this;
  }

  var _proto2 = TabItem.prototype;

  /**
   * Moves a tab via the keyboard.  Finds the tab index and calls the incrementTab callback.
   *
   * @param e {event} - keyboard event
   * @param direction {number} - direction to move the tab, 1 for right and -1 for left.
   */
  _proto2.handleTabIncrement = function handleTabIncrement(e, direction) {
    var incrementTab = this.props.incrementTab;
    e.preventDefault();
    e.stopPropagation();

    if (incrementTab) {
      var idx = e.target.getAttribute('data-index');
      incrementTab(parseInt(idx, 10), direction, this.props.keyValue);
    }
  };

  _proto2.changeHandler = function changeHandler(event, id) {
    var newText = event.target.textContent || "\xA0"; // If newText isEmpty, newText defaults to a blank space to ensure label prop from Tabs parent component

    this.props.onEditLabel(id, newText);
    event.target.scrollLeft = 0;
  };

  _proto2.assignSvgIconColor = function assignSvgIconColor(node, color) {
    if (node && color) {
      node.style.color = color;
    }
  };

  _proto2.deleteCallback = function deleteCallback() {
    return this.props.onDeletePrompt(this.props.deleteHandler);
  };

  _proto2.render = function render() {
    var _this2 = this;

    var _this$props3 = this.props,
        selected = _this$props3.selected,
        label = _this$props3.label,
        textDir = _this$props3.textDir,
        subTitle = _this$props3.subTitle,
        editable = _this$props3.editable,
        setSelectedNode = _this$props3.setSelectedNode,
        setFocusNode = _this$props3.setFocusNode,
        panelId = _this$props3.panelId,
        onEnter = _this$props3.onEnter,
        onLeave = _this$props3.onLeave,
        index = _this$props3.index,
        title = _this$props3.title,
        deleteHandler = _this$props3.deleteHandler,
        onDeletePrompt = _this$props3.onDeletePrompt,
        disabled = _this$props3.disabled,
        isDragging = _this$props3.isDragging,
        isOver = _this$props3.isOver,
        icon = _this$props3.icon,
        isIconBeforeLabel = _this$props3.isIconBeforeLabel,
        iconPosition = _this$props3.iconPosition,
        iconColor = _this$props3.iconColor,
        disableDrag = _this$props3.disableDrag,
        enableDrag = _this$props3.enableDrag,
        tabButton = _this$props3.tabButton,
        vertical = _this$props3.vertical,
        tooltipOrient = _this$props3.tooltipOrient,
        others = (0, _objectWithoutPropertiesLoose2["default"])(_this$props3, ["selected", "label", "textDir", "subTitle", "editable", "setSelectedNode", "setFocusNode", "panelId", "onEnter", "onLeave", "index", "title", "deleteHandler", "onDeletePrompt", "disabled", "isDragging", "isOver", "icon", "isIconBeforeLabel", "iconPosition", "iconColor", "disableDrag", "enableDrag", "tabButton", "vertical", "tooltipOrient"]);
    var onClick;

    if (this.props.disabled === true) {
      onClick = function onClick(e) {
        e.stopPropagation();
      };
    } else {
      onClick = this.props.onClick;
    }

    var className = (0, _utils.classnames)('ba-common-tabList__item', {
      selected: selected,
      label: !!label,
      disabled: disabled,
      editable: editable,
      dragging: isDragging,
      dragDivider: isOver && this.state.dragDivider,
      tabButton: tabButton
    }, isOver && this.state.dragDivider ? "dragDivider-" + this.state.dragDivider : undefined);
    var lineStyle;

    if (selected) {
      switch (this.props.linePositionClass) {
        case 'line-position-top':
          lineStyle = "0px 3px 0 " + this.props.lineColor + " inset";
          break;

        case 'line-position-left':
          lineStyle = "3px 0px 0 " + this.props.lineColor + " inset";
          break;

        case 'line-position-right':
          lineStyle = "-3px 0px 0 " + this.props.lineColor + " inset";
          break;

        case 'line-position-bottom':
          lineStyle = "0px -3px 0 " + this.props.lineColor + " inset";
          break;

        default:
          break;
      }
    }

    var themeBackgroundColor = this.state.themeHover && this.props.hoverColor ? this.props.hoverColor : this.props.backgroundColor;
    var style = (0, _extends2["default"])({}, this.props.backgroundColor || this.props.hoverColor ? {
      backgroundColor: themeBackgroundColor
    } : {}, {
      color: this.props.textColor
    }, this.props.lineColor ? {
      boxShadow: lineStyle
    } : {});
    var deleteStyles = (0, _extends2["default"])({}, this.props.deleteBackgroundColor ? {
      backgroundColor: this.props.deleteBackgroundColor
    } : {});
    var cProps = (0, _extends2["default"])({}, (0, _lodash.omit)(others, 'lineColor', 'backgroundColor', 'hoverColor', 'assignTabLabelRef', 'id', 'keyValue', 'linePositionClass', 'moveTab', 'onEditLabel', 'onLabelBlur', 'pinnable', 'resizable', 'value', 'incrementTab', 'isDraggingCallback', 'deleteable', 'keepTabContent'), {
      onFocus: function onFocus(e) {
        setFocusNode(e.currentTarget);
      },
      onBlur: function onBlur(e) {
        setFocusNode(null);
        onLeave(e.currentTarget);
      },
      onKeyUp: function onKeyUp(e) {
        return onLeave(e.currentTarget);
      },
      onKeyDown: this.onKeyDown,
      onMouseEnter: function onMouseEnter(e) {
        return onEnter(e.currentTarget);
      },
      tabIndex: selected ? 0 : -1,
      'aria-selected': selected,
      'aria-controls': panelId,
      ref: function ref(tab) {
        _this2.tabEl = tab;

        if (selected) {
          setSelectedNode(tab);
        }

        _this2.props.assignTabLabelRef(tab);
      },
      className: className,
      onClick: onClick
    });

    var flyout = this.state.flyoutOpen && this.props.toolbar && this.props.selected && /*#__PURE__*/_react["default"].createElement(_flyout.Flyout, {
      className: "tab-item-flyout-container",
      placement: "bottom",
      padding: "default",
      hideArrow: true,
      domNodeToAttachTo: document.body,
      onClose: this.closeToolbar
    }, /*#__PURE__*/_react["default"].createElement(_toolbar["default"], {
      tabIndex: 0
    }, this.props.toolbar.map(function (element, i) {
      return /*#__PURE__*/_react["default"].createElement(_svgicon["default"], {
        iconId: element.icon.id,
        size: "small",
        key: i,
        className: "ba-common-toolbar__item",
        onClick: function onClick() {
          element.handler();

          _this2.setState(function (state) {
            return {
              flyoutOpen: !state.flyoutOpen
            };
          });
        },
        focusable: true,
        tabIndex: 0
      });
    })));

    var iconPositionClass = '';

    if (isIconBeforeLabel || iconPosition === 'left') {
      iconPositionClass = 'is-left-positioned-icon';
    } else if (iconPosition === 'top') {
      iconPositionClass = 'is-top-positioned-icon';
    } else if (iconPosition === 'bottom') {
      iconPositionClass = 'is-bottom-positioned-icon';
    }

    var isOnlyIconClass = !label ? ' is-only-icon-tab' : '';
    var labelIconSize = label ? 'small' : 'normal';
    var iconClassName = this.props.className ? this.props.className : '';
    var labelIcon = icon ? /*#__PURE__*/_react["default"].createElement(_svgicon["default"], {
      className: "ba-common-tabList__labelIcon " + iconClassName + " " + isOnlyIconClass + " " + iconPositionClass,
      ref: function ref(node) {
        _this2.assignSvgIconColor((0, _reactDom.findDOMNode)(node), iconColor);
      },
      iconId: icon,
      size: labelIconSize
    }) : '';

    var dismissButton = !this.state.editActive && /*#__PURE__*/_react["default"].createElement(_svgicon["default"], {
      iconId: _close_["default"].id,
      size: "small",
      ref: function ref(node) {
        _this2.assignSvgIconColor((0, _reactDom.findDOMNode)(node), _this2.props.deleteIconColor);
      },
      onClick: function onClick(e) {
        e.stopPropagation();

        if (onDeletePrompt) {
          _this2.deleteCallback();
        } else {
          deleteHandler();
        }
      }
    });

    return /*#__PURE__*/_react["default"].createElement(_tooltip["default"], {
      title: title || this.state.label,
      delay: true,
      orient: tooltipOrient,
      display: vertical ? 'block' : 'inline-block',
      className: "flyout-wrapper ba-common-tabList__tooltip",
      onDoubleClick: this.onDoubleClickHandler,
      disabled: isDragging || this.state.flyoutOpen,
      onKeyDown: this.onKeyDown
    }, /*#__PURE__*/_react["default"].createElement("div", (0, _extends2["default"])({
      "data-tid": "tabItem" + index
    }, cProps, {
      onMouseOver: this.themeHoverOn,
      onMouseLeave: this.themeHoverOff,
      style: style,
      role: "tab",
      "data-index": index
    }), isOver, /*#__PURE__*/_react["default"].createElement("div", {
      className: "ba-common-tabList__label__container"
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "ba-common-tabList__label" + isOnlyIconClass,
      id: "label-" + index,
      onKeyPress: this.onKeyPress,
      onClick: this.onLabelClick
    }, label ? /*#__PURE__*/_react["default"].createElement(_TabLabel["default"], {
      className: "ba-common-tabList__labelText " + iconPositionClass,
      contentEditable: !disabled && selected && editable !== false,
      changeHandler: function changeHandler(event) {
        _this2.changeHandler(event, _this2.props.keyValue);
      },
      focusHandler: this.focusHandler,
      ref: function ref(input) {
        _this2.tabLabel = input;
      },
      label: label,
      textDir: textDir,
      tabButton: tabButton,
      disableDrag: disableDrag,
      enableDrag: enableDrag,
      onLabelBlur: function onLabelBlur() {
        _this2.props.onLabelBlur();
      },
      hideDismiss: this.hideDismiss
    }) : '', labelIcon), dismissButton && !disabled ? /*#__PURE__*/_react["default"].createElement("span", {
      className: "ba-common-tabList__itemIcon close",
      style: deleteStyles
    }, dismissButton) : null, /*#__PURE__*/_react["default"].createElement("div", {
      className: "subTitle"
    }, subTitle))), flyout);
  };

  return TabItem;
}(_react.Component);

exports["default"] = TabItem;
(0, _defineProperty2["default"])(TabItem, "propTypes", {
  className: _propTypes["default"].string,
  panelId: _propTypes["default"].string.isRequired,
  setSelectedNode: _propTypes["default"].func.isRequired,
  setFocusNode: _propTypes["default"].func.isRequired,
  onClick: _propTypes["default"].func.isRequired,
  isDragging: _propTypes["default"].bool,
  isOver: _propTypes["default"].bool,
  index: _propTypes["default"].number.isRequired,
  tooltipOrient: _propTypes["default"].oneOf(['top', 'bottom', 'left', 'right']),
  selected: _propTypes["default"].bool,
  deleteable: _propTypes["default"].bool,
  editable: _propTypes["default"].bool,
  disabled: _propTypes["default"].bool,
  vertical: _propTypes["default"].bool,
  isIconBeforeLabel: _propTypes["default"].bool,
  iconPosition: _propTypes["default"].oneOf(['top', 'bottom', 'left', 'right']),
  label: _propTypes["default"].string,
  subTitle: _propTypes["default"].string,
  title: _propTypes["default"].string,
  keyValue: _propTypes["default"].string,
  icon: _propTypes["default"].string,
  backgroundColor: _propTypes["default"].string,
  hoverColor: _propTypes["default"].string,
  deleteBackgroundColor: _propTypes["default"].string,
  deleteIconColor: _propTypes["default"].string,
  textColor: _propTypes["default"].string,
  linePositionClass: _propTypes["default"].string,
  lineColor: _propTypes["default"].string,
  iconColor: _propTypes["default"].string,
  textDir: _propTypes["default"].oneOf(['', 'ltr', 'rtl', 'auto']),
  onEnter: _propTypes["default"].func,
  onLeave: _propTypes["default"].func,
  onEditLabel: _propTypes["default"].func,
  deleteHandler: _propTypes["default"].func,
  toolbar: _propTypes["default"].array,
  incrementTab: _propTypes["default"].func,
  onDragStart: _propTypes["default"].func,
  onDeletePrompt: _propTypes["default"].func,
  disableDrag: _propTypes["default"].func,
  enableDrag: _propTypes["default"].func,
  assignTabLabelRef: _propTypes["default"].func,
  onLabelBlur: _propTypes["default"].func,
  tabButton: _propTypes["default"].bool
});
(0, _defineProperty2["default"])(TabItem, "defaultProps", {
  isIconBeforeLabel: false,
  editable: false,
  tooltipOrient: 'bottom',
  iconPosition: 'right'
});

/***/ }),

/***/ 123:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports["default"] = void 0;

/* IBM Confidential
 *
 * OCO Source Materials
 *
 * IBM Cognos Products: ba-ui-toolkit
 * (C) Copyright IBM Corp. 2019
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U.S. Copyright Office.
 * NLS_ENCODING=UTF-8
 * NLS_MESSAGEFORMAT_NONE
 */
var _default = {
  TAB: 'tab'
};
exports["default"] = _default;

/***/ }),

/***/ 124:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

exports.__esModule = true;
exports["default"] = void 0;

var _utils = __webpack_require__(4);

var _TabsResources = _interopRequireDefault(__webpack_require__(508));

/* IBM Confidential
*
* OCO Source Materials
*
* IBM Cognos Products: ba-ui-toolkit
* (C) Copyright IBM Corp. 2019
*
* The source code for this program is not published or otherwise
* divested of its trade secrets, irrespective of what has been
* deposited with the U.S. Copyright Office.
* NLS_ENCODING=UTF-8
* NLS_MESSAGEFORMAT_NONE
*/
// eslint-disable-line
var _default = new _utils.StringResource(_TabsResources["default"]);

exports["default"] = _default;

/***/ }),

/***/ 125:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

exports.__esModule = true;
exports["default"] = void 0;

var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(5));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(6));

var _react = __webpack_require__(1);

var _propTypes = _interopRequireDefault(__webpack_require__(3));

/* IBM Confidential
 *
 * OCO Source Materials
 *
 * IBM Cognos Products: ba-ui-toolkit
 * (C) Copyright IBM Corp. 2019
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U.S. Copyright Office.
 * NLS_ENCODING=UTF-8
 * NLS_MESSAGEFORMAT_NONE
 */
var TabPanel = /*#__PURE__*/function (_Component) {
  (0, _inheritsLoose2["default"])(TabPanel, _Component);

  function TabPanel() {
    return _Component.apply(this, arguments) || this;
  }

  return TabPanel;
}(_react.Component);

exports["default"] = TabPanel;
(0, _defineProperty2["default"])(TabPanel, "propTypes", {
  className: _propTypes["default"].string,
  id: _propTypes["default"].string.isRequired,
  label: _propTypes["default"].string,
  subTitle: _propTypes["default"].string,
  title: _propTypes["default"].string,
  icon: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].node]),
  isIconBeforeLabel: _propTypes["default"].bool,
  iconPosition: _propTypes["default"].oneOf(['top', 'bottom', 'left', 'right']),
  children: _propTypes["default"].node,
  slideout: _propTypes["default"].bool,
  keepTabContent: _propTypes["default"].bool,
  resizable: _propTypes["default"].bool,
  pinnable: _propTypes["default"].bool,
  resizeMaxConstraintsX: _propTypes["default"].number,
  resizeMinConstraintsX: _propTypes["default"].number,
  resizeMaxConstraintsY: _propTypes["default"].number,
  resizeMinConstraintsY: _propTypes["default"].number,
  tooltipOrient: _propTypes["default"].oneOf(['top', 'bottom', 'left', 'right']),
  width: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]) // vertical tabs

});
(0, _defineProperty2["default"])(TabPanel, "defaultProps", {
  resizable: false,
  pinnable: false,
  tooltipOrient: 'bottom'
});

/***/ }),

/***/ 13:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__13__;

/***/ }),

/***/ 14:
/***/ (function(module, exports) {

module.exports = require("react-dom");

/***/ }),

/***/ 16:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__16__;

/***/ }),

/***/ 18:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__18__;

/***/ }),

/***/ 2:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/interopRequireWildcard");

/***/ }),

/***/ 20:
/***/ (function(module, exports) {

module.exports = require("lodash");

/***/ }),

/***/ 21:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__21__;

/***/ }),

/***/ 26:
/***/ (function(module, exports) {

module.exports = require("react-dnd");

/***/ }),

/***/ 28:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__28__;

/***/ }),

/***/ 3:
/***/ (function(module, exports) {

module.exports = require("prop-types");

/***/ }),

/***/ 31:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__31__;

/***/ }),

/***/ 32:
/***/ (function(module, exports) {

module.exports = require("react-measure");

/***/ }),

/***/ 39:
/***/ (function(module, exports) {

module.exports = require("@ba/ba-graphics/dist/icons-js/close_16");

/***/ }),

/***/ 4:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__4__;

/***/ }),

/***/ 5:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/inheritsLoose");

/***/ }),

/***/ 501:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(502);


/***/ }),

/***/ 502:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

exports.__esModule = true;

var _Tabs = _interopRequireDefault(__webpack_require__(503));

exports["default"] = _Tabs["default"];
exports.Tabs = _Tabs["default"];

var _TabPanel = _interopRequireDefault(__webpack_require__(125));

exports.TabPanel = _TabPanel["default"];

var _TabItem = _interopRequireDefault(__webpack_require__(122));

exports.TabItem = _TabItem["default"];

/***/ }),

/***/ 503:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(2);

var _interopRequireDefault = __webpack_require__(0);

exports.__esModule = true;
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(7));

var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(11));

var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(5));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(6));

var _react = _interopRequireWildcard(__webpack_require__(1));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _utils = __webpack_require__(4);

var _flexlayout = __webpack_require__(16);

var _slideout = _interopRequireDefault(__webpack_require__(88));

var _container = _interopRequireDefault(__webpack_require__(18));

var _lodash = __webpack_require__(20);

var _TabList = _interopRequireDefault(__webpack_require__(504));

var _TabPanel = _interopRequireDefault(__webpack_require__(125));

__webpack_require__(56);

var _StringResource = _interopRequireDefault(__webpack_require__(124));

/* IBM Confidential
 *
 * OCO Source Materials
 *
 * IBM Cognos Products: ba-ui-toolkit
 * (C) Copyright IBM Corp. 2019
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U.S. Copyright Office.
 * NLS_ENCODING=UTF-8
 * NLS_MESSAGEFORMAT_NONE
 */
var BaPropTypes = _utils.propsUtils.BaPropTypes;
var uniqueId = _utils.lodash.uniqueId,
    findIndex = _utils.lodash.findIndex,
    isEqual = _utils.lodash.isEqual;

function getTabIndex(componentChildren, tabProps) {
  var children = _react.Children.toArray(componentChildren);

  var index = findIndex(children, function (_ref) {
    var props = _ref.props;
    return props.id === tabProps.selected;
  });
  return index >= 0 ? index : -1;
}

var Tabs = /*#__PURE__*/function (_Component) {
  (0, _inheritsLoose2["default"])(Tabs, _Component);

  function Tabs() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _Component.call.apply(_Component, [this].concat(args)) || this;
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "state", {
      selectedIndex: getTabIndex(_this.props.children, _this.props),
      selectedChanged: false,
      newTabAdded: false
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_id", uniqueId('__tabs_'));
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_renderedTabs", {});
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_onChange", function (value, id) {
      if (_this.props.selected === undefined) {
        // internally controlled
        _this.setState({
          selectedIndex: id,
          selectedChanged: true
        });
      } // this part controls the toggle for tabbed slideout


      if (_this.state.selectedIndex === id && _this.props.slideout) {
        _this.setState({
          selectedIndex: -1
        }); // this.props.onChange(value, id);

      } else {
        _this.props.onChange && _this.props.onChange(value, id);
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "deleteHandler", function (value, i) {
      var currentTab = _this.state.selectedIndex;
      var obj = _this.props.stateTabs;
      var arr = [];
      Object.keys(obj).forEach(function (v) {
        if (obj[v].props.id !== value) {
          arr.push(obj[v]);
        }
      });

      _this.props.setState(arr);

      if (arr.length === 0) {
        /* If there are no tabs, select none */
        _this.setState({
          selectedIndex: null
        });
      } else if (currentTab === i) {
        /* If the tab you delete is the selected tab, select the one before it, or the first tab */
        var newId = Math.max(i - 1, 0);

        _this.setState({
          selectedIndex: newId,
          selectedChanged: true
        });

        _this.props.onChange && _this.props.onChange(arr[newId].props.id, newId);
      } else if (currentTab > _this.props.children.length - 1 || currentTab > i) {
        /* If the selected index is the last tab, move left one OR the deleted one is before the selected one */
        var _newId = Math.max(currentTab - 1, 0);

        _this.setState({
          selectedIndex: _newId,
          selectedChanged: true
        });

        _this.props.onChange && _this.props.onChange(arr[_newId].props.id, _newId);
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "addNewTab", function () {
      var stateTabsObject = _this.props.stateTabs;
      var id = uniqueId();
      stateTabsObject.push( /*#__PURE__*/_react["default"].createElement(_TabPanel["default"], {
        id: id,
        key: id,
        label: "Untitled " + id,
        subTitle: "Subtitle"
      }, _StringResource["default"].get('newContent') + " " + id));

      _this.setState({
        newTabAdded: true
      });

      _this.props.setState(stateTabsObject);
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "moveTab", function (dragIndex, hoverIndex, dropped, tabId) {
      var stateTabsObject = _this.props.stateTabs;
      var dragTab = stateTabsObject[dragIndex];
      _this.props.onChange && _this.props.onChange(dragTab.props.id);

      _this.arrayMove(stateTabsObject, dragIndex, hoverIndex);

      _this.props.setState(stateTabsObject);

      _this.setState({
        selectedIndex: hoverIndex
      }, function () {
        dropped && _this.props.onReorder && _this.props.onReorder(hoverIndex, tabId);
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "incrementTab", function (fromIndex, direction, tabId) {
      var tabs = _this.props.stateTabs;

      if (!tabs) {
        return;
      }

      var toIndex = fromIndex + direction; // wrap position

      if (toIndex < 0) {
        toIndex = tabs.length - 1;
      }

      if (toIndex > tabs.length - 1) {
        toIndex = 0;
      }

      _this.moveTab(fromIndex, toIndex, true, tabId);
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onEditLabel", function (value, newLabel) {
      var stateTabsObject = _this.props.stateTabs;
      var newEl;

      _react.Children.toArray(stateTabsObject).forEach(function (item, index) {
        if (item.props.id === value) {
          newEl = (0, _react.cloneElement)(item, {
            label: newLabel
          });
          stateTabsObject[index] = newEl;
        }
      });

      _this.forceUpdate();
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "setClickedTrue", function () {
      _this.setState({
        clicked: true
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "setClickedFalse", function () {
      _this.setState({
        clicked: false
      });
    });
    return _this;
  }

  var _proto = Tabs.prototype;

  _proto.componentWillReceiveProps = function componentWillReceiveProps(props) {
    var i = getTabIndex(props.children, props);

    if (i >= 0 && i !== this.state.selectedIndex) {
      this.setState({
        selectedIndex: i,
        selectedChanged: true
      });
    }

    if (i < 0) {
      this.setState({
        selectedIndex: -1
      });
    }

    if (!isEqual(props.newTabContent, this.props.newTabContent)) {// this.addNewTab(props);
    }
  };

  _proto.componentDidUpdate = function componentDidUpdate() {
    if (this.state.newTabAdded) {
      if (this.props.scrollWhenAdded) {
        this.refs.tablist.scrollTabIntoView(this.refs.tablist._innerNode.firstChild.lastChild);
      }

      this.setState({
        newTabAdded: false
      });
    }

    if (this.state.selectedChanged) {
      if (this.props.scrollWhenSelected) {
        this.refs.tablist.scrollTabIntoView();
      }

      this.setState({
        selectedChanged: false
      });
    }
  };

  _proto.componentDidMount = function componentDidMount() {
    if (this.props.scrollWhenSelected && this.refs.tablist) {
      this.refs.tablist.scrollTabIntoView();
    }
  };

  _proto.arrayMove = function arrayMove(arr, fromIndex, toIndex) {
    var element = arr[fromIndex];
    arr.splice(fromIndex, 1);
    arr.splice(toIndex, 0, element);
  };

  _proto.render = function render() {
    var _cx,
        _this2 = this;

    var _this$props = this.props,
        overflow = _this$props.overflow,
        align = _this$props.align,
        multiLine = _this$props.multiLine,
        vertical = _this$props.vertical,
        slideout = _this$props.slideout,
        pinAll = _this$props.pinAll,
        draggable = _this$props.draggable,
        className = _this$props.className,
        style = _this$props.style,
        pageLevel = _this$props.pageLevel,
        tabButton = _this$props.tabButton,
        addTabToolTipText = _this$props.addTabToolTipText,
        textDir = _this$props.textDir,
        scrollButtonsBackgroundColor = _this$props.scrollButtonsBackgroundColor,
        scrollButtonsTextColor = _this$props.scrollButtonsTextColor,
        scrollButtonsHoverColor = _this$props.scrollButtonsHoverColor,
        onDeletePrompt = _this$props.onDeletePrompt,
        placement = _this$props.placement;
    var _this$props2 = this.props,
        deleteable = _this$props2.deleteable,
        editable = _this$props2.editable,
        addable = _this$props2.addable;

    if (pageLevel) {
      deleteable = true;
      editable = true;
      addable = true;
    }

    var selectedIndex = this.state.selectedIndex;
    var linePositionClass;
    var tabsPlacementClass;
    var verticalPlacement;

    if (placement) {
      tabsPlacementClass = placement ? "tabs-placement-" + placement : false;
      verticalPlacement = placement === 'left' || placement === 'right';
    } else {
      verticalPlacement = vertical;
    }

    if (!tabButton) {
      linePositionClass = 'line-position-bottom';

      if (verticalPlacement) {
        linePositionClass = 'line-position-left';
      }

      if (this.props.linePosition) {
        linePositionClass = "line-position-" + this.props.linePosition;
      }
    } else if (tabButton) {
      linePositionClass = 'line-position-none';
    }

    var classNames = (0, _utils.classnames)('ba-common-tabList__container', linePositionClass, tabsPlacementClass, (_cx = {
      deleteable: deleteable,
      multiLine: multiLine,
      vertical: verticalPlacement,
      slideout: slideout,
      clicked: this.state.clicked
    }, _cx["align_" + align] = align === 'center' || align === 'end', _cx));

    var children = _react.Children.toArray(this.props.children).filter(function (child) {
      return child !== null;
    });

    var renderedTabs = {};

    var result = /*#__PURE__*/_react["default"].createElement("div", {
      direction: "column",
      className: classNames + " " + className,
      style: style,
      onMouseDown: this.setClickedTrue,
      onKeyUp: this.setClickedFalse
    }, /*#__PURE__*/_react["default"].createElement(_flexlayout.FlexItem, {
      gutter: [1, 0, 0],
      style: {
        position: 'relative'
      },
      ref: function ref(node) {
        slideout && !_this2.state.node && _this2.setState({
          node: node
        });
      }
    }, /*#__PURE__*/_react["default"].createElement(_TabList["default"], {
      ref: "tablist",
      scrollButtonsBackgroundColor: scrollButtonsBackgroundColor,
      scrollButtonsTextColor: scrollButtonsTextColor,
      scrollButtonsHoverColor: scrollButtonsHoverColor,
      draggable: draggable,
      selectedIndex: selectedIndex,
      deleteable: deleteable,
      multiLine: multiLine,
      editable: editable,
      vertical: verticalPlacement,
      tabButton: tabButton,
      addable: addable,
      textDir: textDir,
      deleteHandler: this.deleteHandler,
      onDeletePrompt: onDeletePrompt,
      onChange: this._onChange,
      onEditLabel: this.onEditLabel,
      linePositionClass: linePositionClass,
      addTabToolTipText: addTabToolTipText,
      onAddButtonClick: function onAddButtonClick() {
        (_this2.props.onAddButtonClick || _this2.addNewTab)(); // this.props.onAddButtonClick

      },
      moveTab: this.moveTab,
      incrementTab: this.incrementTab,
      options: _react.Children.map(children, function (_ref2) {
        var props = _ref2.props;
        return (0, _extends2["default"])({}, (0, _lodash.omit)(props, 'children', 'id', 'pinnable', 'resizable', 'resizeMaxConstraintsX', 'resizeMinConstraintsX'), {
          panelId: _this2._id + "-" + props.id + "_panel",
          value: props.id,
          editable: !slideout && props.editable,
          toolbar: _this2.props.toolbar
        });
      })
    }), slideout && _react.Children.map(children, function (child, i) {
      var props = child.props;
      var selected = selectedIndex === i; // track if tab is previously rendered

      var renderTab = !props.disabled && (props.keepTabContent && _this2._renderedTabs[props.id] || selected);
      renderedTabs[props.id] = renderTab;
      var tabId = _this2._id + "-" + props.id;
      var slideoutProps = {
        active: selected,
        resizable: child.props.resizable,
        resizeMaxConstraintsX: child.props.resizeMaxConstraintsX,
        resizeMinConstraintsX: child.props.resizeMinConstraintsX,
        resizeMaxConstraintsY: child.props.resizeMaxConstraintsY,
        resizeMinConstraintsY: child.props.resizeMinConstraintsY,
        containerRef: _this2.state.node,
        width: child.props.width
      };

      if (!pinAll && !child.props.pinnable) {
        slideoutProps.onClickAway = function () {
          if (selected) {
            _this2.setState({
              selectedIndex: -1
            });
          }
        };
      }

      return /*#__PURE__*/_react["default"].createElement(_slideout["default"], slideoutProps, /*#__PURE__*/_react["default"].createElement("div", {
        key: props.id,
        id: tabId + "_panel",
        role: "tabpanel",
        className: "tabpanel",
        "aria-labelledby": tabId,
        "aria-hidden": !selected,
        overflow: overflow
      }, _react["default"].Children.map(props.children, function (innerChild) {
        return innerChild;
      })));
    })), !slideout && /*#__PURE__*/_react["default"].createElement(_container["default"], {
      relative: true,
      overflow: overflow,
      className: "ba-common-tabList__innerContainer"
    }, _react.Children.map(children, function (child, i) {
      var props = child.props;
      var selected = selectedIndex === i; // track if tab is previously rendered

      var renderTab = !props.disabled && (props.keepTabContent && _this2._renderedTabs[props.id] || selected);
      renderedTabs[props.id] = renderTab;
      var tabId = _this2._id + "-" + props.id;
      return /*#__PURE__*/_react["default"].createElement("div", {
        key: props.id,
        id: tabId + "_panel",
        role: "tabpanel",
        className: "tabpanel",
        "aria-labelledby": tabId,
        style: {
          display: selected ? 'block' : 'none'
        },
        "aria-hidden": !selected,
        overflow: overflow
      }, renderTab ? _react["default"].Children.map(props.children, function (innerChild) {
        return innerChild;
      }) : null);
    })));

    this._renderedTabs = renderedTabs;
    return result;
  };

  return Tabs;
}(_react.Component);

exports["default"] = Tabs;
(0, _defineProperty2["default"])(Tabs, "propTypes", {
  draggable: _propTypes["default"].bool,
  selected: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
  children: _propTypes["default"].node.isRequired,
  onChange: _propTypes["default"].func,
  onAddButtonClick: _propTypes["default"].func,
  addable: _propTypes["default"].bool,
  scrollWhenSelected: _propTypes["default"].bool,
  scrollWhenAdded: _propTypes["default"].bool,
  onReorder: _propTypes["default"].func,
  setState: _propTypes["default"].func,
  onDeletePrompt: _propTypes["default"].func,
  deleteable: _propTypes["default"].bool,
  multiLine: _propTypes["default"].bool,
  editable: _propTypes["default"].bool,
  pageLevel: BaPropTypes.deprecated('It will be removed soon, use "editable" and "deleteable" properties instead.'),
  vertical: _propTypes["default"].bool,
  placement: _propTypes["default"].oneOf(['top', 'bottom', 'left', 'right']),
  tabButton: _propTypes["default"].bool,
  overflow: _propTypes["default"].string,
  className: _propTypes["default"].string,
  linePosition: _propTypes["default"].string,
  addTabToolTipText: _propTypes["default"].string,
  newTabContent: _propTypes["default"].object,
  stateTabs: _propTypes["default"].array,
  slideout: _propTypes["default"].bool,
  pinAll: _propTypes["default"].bool,
  toolbar: _propTypes["default"].array,
  align: _propTypes["default"].oneOf(['start', 'end', 'left', 'center', 'right']),
  style: _propTypes["default"].object,
  textDir: _propTypes["default"].oneOf(['', 'ltr', 'rtl', 'auto']),
  scrollButtonsBackgroundColor: _propTypes["default"].string,
  scrollButtonsTextColor: _propTypes["default"].string,
  scrollButtonsHoverColor: _propTypes["default"].string
});
(0, _defineProperty2["default"])(Tabs, "defaultProps", {
  scrollWhenSelected: true,
  scrollWhenAdded: false,
  align: 'start',
  pinAll: false,
  className: '',
  style: {}
});

/***/ }),

/***/ 504:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(2);

var _interopRequireDefault = __webpack_require__(0);

exports.__esModule = true;
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(7));

var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(11));

var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(5));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(6));

var _react = _interopRequireWildcard(__webpack_require__(1));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _reactMeasure = _interopRequireDefault(__webpack_require__(32));

var _utils = __webpack_require__(4);

var _svgicon = _interopRequireDefault(__webpack_require__(13));

var _tooltip = _interopRequireDefault(__webpack_require__(21));

var _add_ = _interopRequireDefault(__webpack_require__(72));

var _lodash = __webpack_require__(20);

var _TabItem = _interopRequireWildcard(__webpack_require__(122));

var _TabScrollButton = _interopRequireWildcard(__webpack_require__(507));

var _StringResource = _interopRequireDefault(__webpack_require__(124));

__webpack_require__(56);

/* eslint-disable react/no-did-update-set-state */

/* eslint-disable react/no-unused-state */

/* IBM Confidential
 *
 * OCO Source Materials
 *
 * IBM Cognos Products: ba-ui-carbon-toolkit
 * (C) Copyright IBM Corp. 2019, 2020
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U.S. Copyright Office.
 * NLS_ENCODING=UTF-8
 * NLS_MESSAGEFORMAT_NONE
 */
var uniqueId = _utils.lodash.uniqueId; // TODO: might be able to export two a version of TabList(TabList & DnDTabList) later

var TabList = /*#__PURE__*/function (_Component) {
  (0, _inheritsLoose2["default"])(TabList, _Component);

  function TabList() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _Component.call.apply(_Component, [this].concat(args)) || this;
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "state", {
      lineWidth: 0,
      lineLeft: 0,
      lineWidth2: 0,
      lineLeft2: 0
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_id", uniqueId('__tabList_'));
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_enter", function (n) {
      _this.setState({
        lineWidth2: n.offsetWidth,
        lineLeft2: n.offsetLeft
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_leave", function () {
      _this.setState({
        lineWidth2: _this.state.lineWidth,
        lineLeft2: _this.state.lineLeft
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_onKeyDown", function (e) {
      var keyCode = e.keyCode;
      var options = _this.props.options;
      var i = _this.props.selectedIndex;

      switch (keyCode) {
        case 36: // home
        // fall through

        case 38: // up arrow
        // fall through

        case 37:
          if (keyCode === 37 && _this.props.vertical || keyCode === 38 && !_this.props.vertical) {
            break;
          } // left arrow


          if (e.altKey || keyCode === 36) {
            i = 0;
          } else {
            i -= 1;

            if (i < 0) {
              i = options.length - 1;
            }
          }

          e.preventDefault();
          break;

        case 35: // end
        // fall through

        case 40: // down arrow
        // fall through

        case 39:
          if (keyCode === 39 && _this.props.vertical || keyCode === 40 && !_this.props.vertical) {
            break;
          } // right arrow


          if (e.altKey || keyCode === 35) {
            i = options.length - 1;
          } else {
            i += 1;

            if (i === options.length) {
              i = 0;
            }
          }

          e.preventDefault();
          break;

        default:
      }

      _this.props.onChange(options[i].value, i);
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_onScroll", function () {
      _this.setState({
        scrollLeft: _this._innerNode.firstChild.scrollLeft > 4,
        scrollTop: _this._innerNode.firstChild.scrollTop > 4,
        scrollRight: _this._innerNode.firstChild.scrollWidth - _this._innerNode.firstChild.scrollLeft - _this._innerNode.firstChild.offsetWidth > 4,
        scrollBottom: _this._tabList.lastElementChild.offsetTop + _this._tabList.lastElementChild.offsetHeight - (_this._tabList.offsetHeight + _this._innerNode.firstChild.scrollTop) > 4
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_onWheel", function (e) {
      var deltaY = e.deltaY;
      var deltaX = e.deltaX;
      _this._innerNode.firstChild.scrollTop = _this._innerNode.firstChild.scrollTop + deltaY;
      _this._innerNode.firstChild.scrollLeft = _this._innerNode.firstChild.scrollLeft + deltaX;
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "scrollList", function (direction) {
      if (direction === 'left') {
        _this._innerNode.firstChild.scrollLeft = _this._innerNode.firstChild.scrollLeft - 80;
      }

      if (direction === 'right') {
        _this._innerNode.firstChild.scrollLeft = _this._innerNode.firstChild.scrollLeft + 80;
      }

      if (direction === 'top') {
        _this._innerNode.firstChild.scrollTop = _this._innerNode.firstChild.scrollTop - 80;
      }

      if (direction === 'bottom') {
        _this._innerNode.firstChild.scrollTop = _this._innerNode.firstChild.scrollTop + 80;
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "scrollTabIntoView", function (tab) {
      var viewableArea = _this._innerNode.firstChild.getBoundingClientRect();

      if (!tab) {
        tab = _this._selectedNode;
      }

      if (tab) {
        var position = tab.getBoundingClientRect();

        while (Math.floor(position.left) < Math.floor(viewableArea.left)) {
          _this._innerNode.firstChild.scrollLeft = _this._innerNode.firstChild.scrollLeft - 100;
          viewableArea = _this._innerNode.firstChild.getBoundingClientRect();
          position = tab.getBoundingClientRect();
        }

        while (Math.floor(position.right) > Math.floor(viewableArea.right)) {
          _this._innerNode.firstChild.scrollLeft = _this._innerNode.firstChild.scrollLeft + 100;
          viewableArea = _this._innerNode.firstChild.getBoundingClientRect();
          position = tab.getBoundingClientRect();
        }

        while (Math.floor(position.top) < Math.floor(viewableArea.top)) {
          _this._innerNode.firstChild.scrollTop = _this._innerNode.firstChild.scrollTop - 100;
          viewableArea = _this._innerNode.firstChild.getBoundingClientRect();
          position = tab.getBoundingClientRect();
        }

        while (Math.floor(position.bottom) > Math.floor(viewableArea.bottom)) {
          _this._innerNode.firstChild.scrollTop = _this._innerNode.firstChild.scrollTop + 100;
          viewableArea = _this._innerNode.firstChild.getBoundingClientRect();
          position = tab.getBoundingClientRect();
        }
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_setSelectedNode", function (node) {
      _this._selectedNode = node;
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_setFocusNode", function (node) {
      if (!node) node = _this._selectedNode ? _this._selectedNode : null;
      _this._focusNode = node;
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_refLine", function (node) {
      _this._line = node;
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_refLine2", function (node) {
      _this._line2 = node;
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_refTabList", function (node) {
      _this._tabList = node;
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_refInner", function (node) {
      _this._innerNode = node;
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "deleteHandler", function (value, i) {
      _this.props.deleteHandler && _this.props.deleteHandler(value, i);
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_enableDrag", function () {
      _this.setState({
        dragDisabled: false
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_disableDrag", function () {
      _this.setState({
        dragDisabled: true
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "tabLabelRef", {});
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onLabelBlur", function (i) {
      return function () {
        // using set state to force component to wait to update between switching between TabItem and TabItemDnD before calling .focus()
        _this.setState({}, function () {
          _this.tabLabelRef[i].focus();
        });
      };
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "assignTabLabelRef", function (ref, i) {
      _this.tabLabelRef[i] = ref;
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_isDragging", function (value) {
      _this.setState({
        dragging: value
      });
    });
    return _this;
  }

  var _proto = TabList.prototype;

  _proto.componentDidMount = function componentDidMount() {
    if (this._selectedNode) {
      this.setState({
        lineWidth: this._selectedNode.offsetWidth,
        lineLeft: this._selectedNode.offsetLeft,
        lineWidth2: this._selectedNode.offsetWidth,
        lineLeft2: this._selectedNode.offsetLeft
      });
    }
  };

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    var _this2 = this;

    if (this._selectedNode === null || this._selectedNode === -1 || this._selectedNode === undefined) {
      return;
    }

    var lineWidth = this._selectedNode.offsetWidth;
    var lineLeft = this._selectedNode.offsetLeft;

    if (this.props.selectedIndex !== prevProps.selectedIndex) {
      // assign the line width and height based on the selected node
      this.setState({
        lineWidth: lineWidth,
        lineLeft: lineLeft,
        lineWidth2: lineWidth,
        lineLeft2: lineLeft
      }, // if the focus node is set, this means that focus is on a tab
      // since the selected tab has changed, we need to refocus the new selected node
      this._focusNode ? function () {
        _this2._selectedNode.focus();
      } : null);
    } else if (lineWidth !== this.state.lineWidth || lineLeft !== this.state.lineLeft) {
      // the UI changed and we must resize the lines
      this.setState({
        lineWidth: lineWidth,
        lineLeft: lineLeft,
        lineWidth2: lineWidth,
        lineLeft2: lineLeft
      });
    }

    if (this.props !== prevProps) {
      this._onScroll();
    }
  };

  _proto._onClick = function _onClick(value, i) {
    this.props.onChange(value, i);
  };

  _proto.render = function render() {
    var _this3 = this;

    var _this$props = this.props,
        options = _this$props.options,
        selectedIndex = _this$props.selectedIndex,
        onAddButtonClick = _this$props.onAddButtonClick,
        moveTab = _this$props.moveTab,
        incrementTab = _this$props.incrementTab,
        onEditLabel = _this$props.onEditLabel,
        vertical = _this$props.vertical,
        textDir = _this$props.textDir,
        linePositionClass = _this$props.linePositionClass,
        draggable = _this$props.draggable,
        editable = _this$props.editable,
        tabButton = _this$props.tabButton,
        addable = _this$props.addable,
        addTabToolTipText = _this$props.addTabToolTipText,
        scrollButtonsBackgroundColor = _this$props.scrollButtonsBackgroundColor,
        scrollButtonsTextColor = _this$props.scrollButtonsTextColor,
        scrollButtonsHoverColor = _this$props.scrollButtonsHoverColor,
        onDeletePrompt = _this$props.onDeletePrompt;
    var _this$state = this.state,
        scrollLeft = _this$state.scrollLeft,
        scrollRight = _this$state.scrollRight,
        scrollTop = _this$state.scrollTop,
        scrollBottom = _this$state.scrollBottom;
    var deleteable = this.props.deleteable;

    var onAddButtonKeyDown = function onAddButtonKeyDown(e) {
      // enter key or space bar will simulate a click
      if (e.keyCode === 13 || e.keyCode === 32) {
        e.preventDefault();
        onAddButtonClick && onAddButtonClick();
      }
    };

    var isOnlyIconClass = ' is-only-icon-tab-list';
    options.forEach(function (_ref) {
      var label = _ref.label;

      if (label) {
        isOnlyIconClass = '';
      }
    });
    var listIsDragged = this.state.dragging;
    deleteable = deleteable && !listIsDragged; // Only in use TabScrollButtonDnd if drag and drop is enabled, besides that use regular TabScrollButton

    var TabScrollButtonComponent = draggable ? _TabScrollButton.TabScrollButtonDnd : _TabScrollButton["default"];
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: (0, _utils.classnames)("ba-common-tabList" + isOnlyIconClass, {
        vertical: vertical
      }, {
        deleteable: deleteable
      }, {
        editable: editable
      }, {
        tabButton: tabButton
      }, {
        addable: addable
      })
    }, /*#__PURE__*/_react["default"].createElement(_reactMeasure["default"], {
      onResize: this._onScroll,
      whitelist: ['width']
    }, function (_ref2) {
      var measureRef = _ref2.measureRef;
      return /*#__PURE__*/_react["default"].createElement("div", {
        ref: measureRef
      }, /*#__PURE__*/_react["default"].createElement("nav", {
        className: "ba-common-tabList__inner",
        ref: _this3._refInner
      }, /*#__PURE__*/_react["default"].createElement("ul", {
        className: "ba-common-tabList__list " + linePositionClass,
        onKeyDown: _this3._onKeyDown,
        role: "tablist",
        ref: _this3._refTabList,
        onScroll: _this3._onScroll,
        onWheel: _this3._onWheel.bind(_this3)
      }, _this3.props.options.map(function (props, i) {
        var isDnD = draggable && !_this3.state.dragDisabled;
        var TabItems = isDnD ? _TabItem.TabItemDnD : _TabItem["default"];
        var tabItemDnDProps = {
          incrementTab: incrementTab,
          isDraggingCallback: _this3._isDragging
        };
        return /*#__PURE__*/_react["default"].createElement(TabItems, (0, _extends2["default"])({}, (0, _lodash.omit)(props, 'value'), isDnD ? tabItemDnDProps : {}, {
          deleteHandler: _this3.deleteHandler.bind(_this3, props.value, i),
          key: props.value,
          keyValue: props.value,
          textDir: textDir,
          selected: selectedIndex === i,
          editable: editable,
          deleteable: deleteable,
          vertical: vertical,
          tabButton: tabButton,
          onClick: _this3._onClick.bind(_this3, props.value, i),
          onEnter: _this3._enter,
          onLeave: _this3._leave,
          setSelectedNode: _this3._setSelectedNode,
          setFocusNode: _this3._setFocusNode,
          disableDrag: _this3._disableDrag,
          enableDrag: _this3._enableDrag,
          index: i,
          moveTab: moveTab,
          onEditLabel: onEditLabel,
          linePositionClass: linePositionClass,
          assignTabLabelRef: function assignTabLabelRef(ref) {
            _this3.tabLabelRef[i] = ref;
          },
          onDeletePrompt: onDeletePrompt,
          onLabelBlur: _this3.onLabelBlur(i)
        }));
      })), addable ? /*#__PURE__*/_react["default"].createElement(_tooltip["default"], {
        orient: "top",
        title: addTabToolTipText,
        delay: true
      }, /*#__PURE__*/_react["default"].createElement(_svgicon["default"], {
        "aria-label": addTabToolTipText,
        iconId: _add_["default"].id,
        focusable: true,
        tabIndex: "0",
        className: "addNewIcon",
        onKeyDown: onAddButtonKeyDown,
        onClick: onAddButtonClick
      })) : ''));
    }), /*#__PURE__*/_react["default"].createElement(TabScrollButtonComponent, {
      scrolling: scrollBottom,
      bottom: true,
      scrollHandler: function scrollHandler() {
        return _this3.scrollList('bottom');
      },
      onClick: function onClick() {
        return _this3.scrollList('bottom');
      },
      backgroundColor: scrollButtonsBackgroundColor,
      textColor: scrollButtonsTextColor,
      hoverColor: scrollButtonsHoverColor
    }), /*#__PURE__*/_react["default"].createElement(TabScrollButtonComponent, {
      scrolling: scrollTop,
      top: true,
      scrollHandler: function scrollHandler() {
        return _this3.scrollList('top');
      },
      onClick: function onClick() {
        return _this3.scrollList('top');
      },
      backgroundColor: scrollButtonsBackgroundColor,
      textColor: scrollButtonsTextColor,
      hoverColor: scrollButtonsHoverColor
    }), /*#__PURE__*/_react["default"].createElement(TabScrollButtonComponent, {
      scrolling: scrollLeft,
      left: true,
      scrollHandler: function scrollHandler() {
        return _this3.scrollList('left');
      },
      onClick: function onClick() {
        return _this3.scrollList('left');
      },
      backgroundColor: scrollButtonsBackgroundColor,
      textColor: scrollButtonsTextColor,
      hoverColor: scrollButtonsHoverColor
    }), /*#__PURE__*/_react["default"].createElement(TabScrollButtonComponent, {
      scrolling: scrollRight,
      right: true,
      scrollHandler: function scrollHandler() {
        return _this3.scrollList('right');
      },
      onClick: function onClick() {
        return _this3.scrollList('right');
      },
      backgroundColor: scrollButtonsBackgroundColor,
      textColor: scrollButtonsTextColor,
      hoverColor: scrollButtonsHoverColor
    }));
  };

  return TabList;
}(_react.Component);

exports["default"] = TabList;
(0, _defineProperty2["default"])(TabList, "propTypes", {
  draggable: _propTypes["default"].bool,
  selectedIndex: _propTypes["default"].number.isRequired,
  options: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    value: _propTypes["default"].string,
    label: _propTypes["default"].string,
    icon: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].node]),
    isIconBeforeLabel: _propTypes["default"].bool,
    iconPosition: _propTypes["default"].oneOf(['top', 'bottom', 'left', 'right']),
    title: _propTypes["default"].string
  })).isRequired,
  onChange: _propTypes["default"].func,
  onAddButtonClick: _propTypes["default"].func,
  deleteHandler: _propTypes["default"].func,
  moveTab: _propTypes["default"].func,
  incrementTab: _propTypes["default"].func,
  onDeletePrompt: _propTypes["default"].func,
  deleteable: _propTypes["default"].bool,
  editable: _propTypes["default"].bool,
  multiLine: _propTypes["default"].bool,
  vertical: _propTypes["default"].bool,
  tabButton: _propTypes["default"].bool,
  addable: _propTypes["default"].bool,
  setState: _propTypes["default"].func,
  onEditLabel: _propTypes["default"].func,
  newTabContent: _propTypes["default"].object,
  linePositionClass: _propTypes["default"].string,
  addTabToolTipText: _propTypes["default"].string,
  scrollButtonsBackgroundColor: _propTypes["default"].string,
  scrollButtonsTextColor: _propTypes["default"].string,
  scrollButtonsHoverColor: _propTypes["default"].string,
  textDir: _propTypes["default"].oneOf(['', 'ltr', 'rtl', 'auto'])
});
(0, _defineProperty2["default"])(TabList, "defaultProps", {
  addTabToolTipText: _StringResource["default"].get('addNewTab')
});

/***/ }),

/***/ 505:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(2);

var _interopRequireDefault = __webpack_require__(0);

exports.__esModule = true;
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(7));

var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(11));

var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(5));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(6));

var _react = _interopRequireWildcard(__webpack_require__(1));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _utils = __webpack_require__(4);

/* IBM Confidential
 *
 * OCO Source Materials
 *
 * IBM Cognos Products: ba-ui-toolkit
 * (C) Copyright IBM Corp. 2019
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U.S. Copyright Office.
 * NLS_ENCODING=UTF-8
 * NLS_MESSAGEFORMAT_NONE
 */
var resolveBaseTextDir = _utils.bidiUtils.resolveBaseTextDir;
/**
 * TabLabel is an editable span element that supports cancel/revert via the esc key
 */

var TabLabel = /*#__PURE__*/function (_Component) {
  (0, _inheritsLoose2["default"])(TabLabel, _Component);

  function TabLabel() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _Component.call.apply(_Component, [this].concat(args)) || this;
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_onFocus", function (e) {
      if (_this.props.disableDrag) {
        _this.props.disableDrag();
      }

      _this.labelInitialValue = e.target.textContent;

      _this._selectAllTextInTarget(e.target);

      _this.props.focusHandler && _this.props.focusHandler(true);
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_selectAllTextInTarget", function (target) {
      if (_this._isCreateTextRangeSupported()) {
        var range = document.body.createTextRange();
        range.moveToElementText(target);
        range.select();
      } else if (_this._isGetSelectionSupported()) {
        var selection = window.getSelection();
        var newRange = document.createRange();
        newRange.selectNodeContents(target);
        selection.removeAllRanges();
        selection.addRange(newRange);
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_onBlur", function (e) {
      var _this$props = _this.props,
          enableDrag = _this$props.enableDrag,
          changeHandler = _this$props.changeHandler,
          onLabelBlur = _this$props.onLabelBlur;

      if (e.target.textContent === '') {
        e.target.textContent = _this.labelInitialValue;
      }

      changeHandler(e);

      if (enableDrag) {
        enableDrag();
      }

      onLabelBlur && onLabelBlur();
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_onKeyDown", function (e) {
      e.stopPropagation();

      switch (e.keyCode) {
        // esc key - revert edit
        case 27:
          e.target.textContent = _this.labelInitialValue;
          _this.props.focusOnComplete && _this.props.focusOnComplete();

          _this.props.onLabelBlur();

          break;
        // enter - done focus on parent tab

        case 13:
          _this.props.focusOnComplete && _this.props.focusOnComplete();

          _this.props.onLabelBlur();

          break;

        default:
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_onClick", function () {
      _this.focusOnLabel();
    });
    return _this;
  }

  var _proto = TabLabel.prototype;

  _proto._isCreateTextRangeSupported = function _isCreateTextRangeSupported() {
    if (document.body.createTextRange) return true;
    return false;
  };

  _proto._isGetSelectionSupported = function _isGetSelectionSupported() {
    if (window.getSelection) return true;
    return false;
  };

  _proto.focusOnLabel = function focusOnLabel() {
    if (this.props.contentEditable) {
      this.labelInput.focus();
    }
  };

  _proto.render = function render() {
    var _this2 = this;

    var _this$props2 = this.props,
        className = _this$props2.className,
        contentEditable = _this$props2.contentEditable,
        label = _this$props2.label,
        style = _this$props2.style,
        textDir = _this$props2.textDir;
    var defaultProps = {
      className: className,
      tabIndex: -1,
      ref: function ref(input) {
        _this2.labelInput = input;
      },
      style: style
    };

    if (!contentEditable) {
      return /*#__PURE__*/_react["default"].createElement("span", (0, _extends2["default"])({
        dir: resolveBaseTextDir(label, textDir, false)
      }, defaultProps), label);
    }

    return /*#__PURE__*/_react["default"].createElement("span", (0, _extends2["default"])({}, defaultProps, {
      contentEditable: contentEditable,
      onBlur: this._onBlur,
      onFocus: this._onFocus,
      onKeyDown: this._onKeyDown,
      onClick: this._onClick,
      suppressContentEditableWarning: "true",
      dir: resolveBaseTextDir(label, textDir, false)
    }), label);
  };

  return TabLabel;
}(_react.Component);

exports["default"] = TabLabel;
(0, _defineProperty2["default"])(TabLabel, "propTypes", {
  className: _propTypes["default"].string,
  contentEditable: _propTypes["default"].bool,
  changeHandler: _propTypes["default"].func.isRequired,
  focusOnComplete: _propTypes["default"].func,
  focusHandler: _propTypes["default"].func,
  label: _propTypes["default"].string.isRequired,
  textDir: _propTypes["default"].oneOf(['', 'ltr', 'rtl', 'auto']),
  style: _propTypes["default"].object,
  disableDrag: _propTypes["default"].func,
  enableDrag: _propTypes["default"].func,
  onLabelBlur: _propTypes["default"].func
});
(0, _defineProperty2["default"])(TabLabel, "defaultProps", {
  className: '',
  style: {}
});

/***/ }),

/***/ 506:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(9)(undefined);
// imports


// module
exports.push([module.i, ".ba-common-tabList__item .ba-common-tabList__itemIcon{display:none}use{pointer-events:none}.ba-common-tabList .ba-common-tabList__inner{display:flex;align-items:center}.ba-common-tabList .ba-common-tabList__inner .ba-common-tabList__list{width:fit-content;overflow-x:hidden;overflow-y:hidden}.ba-common-tabList.is-addable .ba-common-tabList__edge__wrapper{user-select:none}.ba-common-tabList.is-addable .ba-common-tabList__edge__wrapper.is-right{right:28px}.ba-common-flyout__container.tab-item-flyout-container{margin-top:8px;padding:0px;width:auto}.ba-common-flyout__container.tab-item-flyout-container .ba-common-toolbar{margin-top:0px;margin-bottom:0px}.ba-common-flyout__container.tab-item-flyout-container .ba-common-toolbar .ba-common-toolbar__item{margin-bottom:0px;padding:4px;cursor:pointer}.flyout-wrapper{display:inline-flex}.ba-common-tabList.is-vertical>div{height:100%}.ba-common-tabList.is-vertical .ba-common-tabList__itemDraggable{display:block}.ba-common-tabList.is-vertical .ba-common-tabList__list{padding-bottom:6px}.ba-common-tabList.is-vertical .flyout-wrapper{display:block}.ba-common-tabList.is-vertical .ba-common-tabList__inner .ba-common-tabList__list{padding-bottom:2px}.ba-common-tabList.is-vertical .ba-common-tabList__inner{display:flex;align-items:center;height:100%}.ba-common-tabList.is-vertical .ba-common-tabList__inner .ba-common-tabList__list{max-height:calc(100% - 40px);max-width:none;width:fit-content;overflow-y:hidden;overflow-x:hidden}.ba-common-tabList.is-vertical .ba-common-tabList__edge__wrapper.is-bottom{height:32px;bottom:28px}.ba-common-tabList.is-vertical .ba-common-tabList__edge__wrapper.is-top{height:32px}.ba-common-tabList__container{height:100%;width:100%}.ba-common-tabList__container.is-clicked .ba-common-tabList__item:focus{border-color:transparent}.ba-common-tabList__container:not(.is-vertical){display:flex;flex-direction:column}.ba-common-tabList__container .ba-common-tabList__innerContainer{height:calc(100% - 40px);width:100%}.ba-common-tabList__container.is-align_center .ba-common-tabList__inner{justify-content:center}.ba-common-tabList__container.is-align_end .ba-common-tabList__inner{justify-content:flex-end}.ba-common-tabList__container>.ba-common-flexLayout-item{padding-top:0px !important}.ba-common-tabList__container .tabpanel{width:100%;height:100%}.ba-common-tabList__container.is-vertical{display:flex}.ba-common-tabList__container.is-vertical .ba-common-tabList__innerContainer{height:100%}.ba-common-tabList__container.is-vertical .ba-common-tabList{height:auto}.ba-common-tabList__container.is-vertical .ba-common-tabList.is-vertical{border-bottom-width:0px;border-right-width:1px}.ba-common-tabList__container.is-vertical .ba-common-tabList__list{width:100%}.ba-common-tabList__container.is-vertical .ba-common-tabList__inner{padding-bottom:initial}.ba-common-tabList__container.is-vertical .ba-common-tabList__item{display:flex;justify-content:flex-start;height:48px}.ba-common-tabList__container.is-vertical .ba-common-tabList__item .subTitle{text-align:center}.ba-common-tabList__container.is-vertical .ba-common-svgIcon.is-small.is-clickable.addNewIcon{display:block !important;margin-left:auto;margin-right:auto;position:relative;z-index:99;top:auto;bottom:-20px}.ba-common-tabList__container.is-vertical .ba-common-tabList__inner{flex-direction:column}.ba-common-tabList__container.is-vertical .ba-common-tabList__inner .ba-common-tabList__list{overflow-x:hidden;overflow-y:hidden;height:auto}.ba-common-tabList__container.is-vertical .ba-common-tabList__inner::-webkit-scrollbar{width:0px;background:transparent}.ba-common-tabList__container.is-vertical .ba-common-tabList{height:100% !important}.ba-common-tabList__container.is-slideout{width:auto}.ba-common-tabList__container.is-slideout .ba-common-tabList__item{height:48px}.ba-common-tabList__container.is-slideout .ba-common-tabList__item[aria-selected=\"true\"]{background-color:#fff}.ba-common-tabList__container.is-slideout>.ba-common-container.ba-common-flexLayout-item .ba-common-slideout-children-wrapper{box-shadow:inset -1px 0px #eaeaea}.ba-common-tabList__container.is-slideout>.ba-common-container.ba-common-flexLayout-item .ba-common-tabList{background-color:#eaeaea;z-index:2}@media screen and (-ms-high-contrast: active){.ba-common-tabList__container .ba-common-svgIcon.is-small.is-clickable.addNewIcon{fill:#fff}}.ba-common-tabList__container.tabs-placement-top{flex-direction:column}.ba-common-tabList__container.tabs-placement-top .ba-common-tabList{border-bottom-width:1px}.ba-common-tabList__container.tabs-placement-bottom{flex-direction:column-reverse}.ba-common-tabList__container.tabs-placement-bottom .ba-common-tabList{border-top-width:1px}.ba-common-tabList__container.tabs-placement-left{flex-direction:row}.ba-common-tabList__container.tabs-placement-left .ba-common-tabList{border-right-width:1px}.ba-common-tabList__container.tabs-placement-right{flex-direction:row-reverse}.ba-common-tabList__container.tabs-placement-right .ba-common-tabList{border-left-width:1px}.ba-common-tabList__container.is-clicked .ba-common-tabList__list.line-position-top .ba-common-tabList[aria-selected=\"true\"]{box-shadow:0px 2px 0 #0f62fe inset;box-shadow:0px 2px 0 var(--interactive-01, #0f62fe) inset}.ba-common-tabList__container.is-clicked .ba-common-tabList__list.line-position-left .ba-common-tabList__item[aria-selected=\"true\"]{box-shadow:2px 0px 0 #0f62fe inset;box-shadow:2px 0px 0 var(--interactive-01, #0f62fe) inset}.ba-common-tabList__container.is-clicked .ba-common-tabList__list.line-position-right .ba-common-tabList__item[aria-selected=\"true\"]{box-shadow:-2px 0px 0 #0f62fe inset;box-shadow:-2px 0px 0 var(--interactive-01, #0f62fe) inset}.ba-common-tabList__container.is-clicked .ba-common-tabList__list.line-position-bottom .ba-common-tabList__item[aria-selected=\"true\"]{box-shadow:0px -2px 0 #0f62fe inset;box-shadow:0px -2px 0 var(--interactive-01, #0f62fe) inset}.ba-common-tabList__container.is-clicked .ba-common-tabList__list.line-position-none .ba-common-tabList__item[aria-selected=\"true\"]{box-shadow:0 0 0 2px #002d9c inset;box-shadow:0 0 0 2px var(--active-primary, #002d9c) inset}.ba-common-tabList__list{height:54px;-ms-overflow-style:none}.ba-common-tabList__list::-webkit-scrollbar{display:none}.ba-common-tabList__list.line-position-top .ba-common-tabList__item:hover:not(.is-disabled){box-shadow:0px 2px 0 #8d8d8d inset;box-shadow:0px 2px 0 var(--ui-04, #8d8d8d) inset}.ba-common-tabList__list.line-position-top .ba-common-tabList__item[aria-selected=\"true\"]{box-shadow:0px 2px 0 #0f62fe inset;box-shadow:0px 2px 0 var(--interactive-01, #0f62fe) inset}@media screen and (-ms-high-contrast: active){.ba-common-tabList__list.line-position-top .ba-common-tabList__item[aria-selected=\"true\"]{border:solid #fff}}.ba-common-tabList__list.line-position-top .ba-common-tabList__item[aria-selected=\"true\"]:focus{box-shadow:0px 2px 0 #0f62fe inset,inset 0px 0px 0px 2px #0f62fe;box-shadow:0px 2px 0 var(--interactive-01, #0f62fe) inset,inset 0px 0px 0px 2px #0f62fe}.ba-common-tabList__list.line-position-top .ba-common-tabList__item[aria-selected=\"true\"]:hover .ba-common-tabList__itemIcon{height:calc(100% - 4px);top:4px}.ba-common-tabList__list.line-position-top .ba-common-tabList__item[aria-selected=\"true\"]:hover .ba-common-tabList__itemIcon .ba-common-svgIcon{top:calc(50% - 10px);left:calc(50% - 8px)}.ba-common-tabList__list.line-position-left .ba-common-tabList__item:hover:not(.is-disabled){box-shadow:2px 0px 0 #8d8d8d inset;box-shadow:2px 0px 0 var(--ui-04, #8d8d8d) inset}.ba-common-tabList__list.line-position-left .ba-common-tabList__item[aria-selected=\"true\"]{box-shadow:2px 0px 0 #0f62fe inset;box-shadow:2px 0px 0 var(--interactive-01, #0f62fe) inset}@media screen and (-ms-high-contrast: active){.ba-common-tabList__list.line-position-left .ba-common-tabList__item[aria-selected=\"true\"]{border:solid #fff}}.ba-common-tabList__list.line-position-left .ba-common-tabList__item[aria-selected=\"true\"]:focus{box-shadow:2px 0px 0 #0f62fe inset,inset 0px 0px 0px 2px #0f62fe;box-shadow:2px 0px 0 var(--interactive-01, #0f62fe) inset,inset 0px 0px 0px 2px #0f62fe}.ba-common-tabList__list.line-position-right .ba-common-tabList__item:hover:not(.is-disabled){box-shadow:-2px 0px 0 #8d8d8d inset;box-shadow:-2px 0px 0 var(--ui-04, #8d8d8d) inset}.ba-common-tabList__list.line-position-right .ba-common-tabList__item[aria-selected=\"true\"]{box-shadow:-2px 0px 0 #0f62fe inset;box-shadow:-2px 0px 0 var(--interactive-01, #0f62fe) inset}@media screen and (-ms-high-contrast: active){.ba-common-tabList__list.line-position-right .ba-common-tabList__item[aria-selected=\"true\"]{border:solid #fff}}.ba-common-tabList__list.line-position-right .ba-common-tabList__item[aria-selected=\"true\"]:focus{box-shadow:-2px 0px 0 #0f62fe inset,inset 0px 0px 0px 2px #0f62fe;box-shadow:-2px 0px 0 var(--interactive-01, #0f62fe) inset,inset 0px 0px 0px 2px #0f62fe}.ba-common-tabList__list.line-position-right .ba-common-tabList__item[aria-selected=\"true\"]:hover .ba-common-tabList__itemIcon{width:20px;right:4px}.ba-common-tabList__list.line-position-right .ba-common-tabList__item[aria-selected=\"true\"]:hover .ba-common-tabList__itemIcon .ba-common-svgIcon{top:calc(50% - 8px);left:calc(50% - 6px)}.ba-common-tabList__list.line-position-bottom .ba-common-tabList__item:hover:not(.is-disabled){box-shadow:0px -2px 0 #8d8d8d inset;box-shadow:0px -2px 0 var(--ui-04, #8d8d8d) inset}.ba-common-tabList__list.line-position-bottom .ba-common-tabList__item[aria-selected=\"true\"]{box-shadow:0px -2px 0 #0f62fe inset;box-shadow:0px -2px 0 var(--interactive-01, #0f62fe) inset}@media screen and (-ms-high-contrast: active){.ba-common-tabList__list.line-position-bottom .ba-common-tabList__item[aria-selected=\"true\"]{border:solid #fff}}.ba-common-tabList__list.line-position-bottom .ba-common-tabList__item[aria-selected=\"true\"]:focus{box-shadow:0px -2px 0 var(--interactive-01, #0f62fe) inset,inset 0px 0px 0px 2px #0f62fe;box-shadow:0px -2px 0 var(--interactive-01, #0f62fe) inset,inset 0px 0px 0px 2px #0f62fe}.ba-common-tabList__list.line-position-bottom .ba-common-tabList__item[aria-selected=\"true\"]:hover .ba-common-tabList__itemIcon{height:calc(100% - 4px);bottom:4px}.ba-common-tabList__list.line-position-bottom .ba-common-tabList__item[aria-selected=\"true\"]:hover .ba-common-tabList__itemIcon .ba-common-svgIcon{top:calc(50% - 6px);left:calc(50% - 8px)}.ba-common-tabList__list.line-position-none .ba-common-tabList__item[aria-selected=\"true\"]{box-shadow:0 0 0 2px #002d9c inset;box-shadow:0 0 0 2px var(--active-primary, #002d9c) inset}@media screen and (-ms-high-contrast: active){.ba-common-tabList__list.line-position-none .ba-common-tabList__item[aria-selected=\"true\"]{background-color:#fff;color:#000}}.ba-common-tabList__list.line-position-none .ba-common-tabList__item[aria-selected=\"true\"]:focus{box-shadow:inset 0px 0px 0px 2px #0f62fe;box-shadow:inset 0px 0px 0px 2px var(--focus, #0f62fe)}.ba-common-tabList.is-deleteable .ba-common-tabList__item:hover .ba-common-tabList__itemIcon{display:inline-flex}.ba-common-tabList .ba-common-svgIcon.is-small.is-clickable.addNewIcon{display:none;color:#8d8d8d}.ba-common-tabList .ba-common-svgIcon.is-small.is-clickable.addNewIcon:hover{color:#0f62fe}.ba-common-tabList .tabContent{margin-top:32px;height:100%}.ba-common-tabList .tabContent .Heading:first-child{margin-top:0}.ba-common-tabList.is-only-icon-tab-list .ba-common-tabList__item{height:48px;width:48px;padding-left:12px;padding-right:12px}.ba-common-tabList.is-only-icon-tab-list .ba-common-tabList__item:focus{padding-left:12px;padding-right:12px}.ba-common-tabList.is-only-icon-tab-list .ba-common-svgIcon.is-small.is-clickable.addNewIcon{margin-top:16px;margin-bottom:16px;top:-4px}.ba-common-tabList.is-vertical .ba-common-tabList__item{height:48px}.ba-common-tabList.is-vertical .ba-common-svgIcon.is-small.is-clickable.addNewIcon{bottom:-8px}.ba-common-tabList .ba-common-tabList__item{height:40px;box-sizing:border-box}.ba-common-tabList .ba-common-tabList__item:hover .ba-common-tabList__itemIcon{position:absolute;background-color:#eaeaea;height:100%;width:24px;right:0;top:0}.ba-common-tabList .ba-common-tabList__item:hover .ba-common-tabList__itemIcon .ba-common-svgIcon{color:#595859;position:absolute;top:calc(50% - 8px);left:calc(50% - 8px)}.ba-common-tabList .ba-common-tabList__item .ba-common-tabList__label{text-align:center}.ba-common-tabList .ba-common-tabList__item .ba-common-tabList__label.is-only-icon-tab{margin-right:0px;color:#595859}.ba-common-tabList.is-addable .ba-common-svgIcon.is-small.is-clickable.addNewIcon{display:inline}.ba-common-tabList .subTitle{display:none;text-overflow:ellipsis;overflow:hidden}.ba-common-tabList{text-align:left;overflow:hidden;height:40px;position:relative;border-width:0;border-bottom-width:1px;border-style:solid}.ba-common-tabList.is-editable .ba-common-tabList__label{font-size:.875rem;line-height:carbon--rem(18px);position:relative}.ba-common-tabList.is-editable .ba-common-tabList__label .ba-common-tabList__labelText:focus{outline:none;font-weight:600;text-overflow:initial;cursor:text}.ba-common-tabList.is-editable .ba-common-tabList__label .ba-common-tabList__labelText:focus .is-removeTextIcon{display:inherit}.ba-common-tabList .is-removeTextIcon{position:absolute;display:none;top:16px;right:8px;color:#595859;z-index:1000}.ba-common-tabList div.ba-common-tabList__item:focus .is-removeTextIcon{display:inline-block}.ba-common-tabList.is-only-icon-tab-list{height:48px}.ba-common-tabList__edge__wrapper{position:absolute;pointer-events:visible;opacity:0;display:none}@media screen and (-ms-high-contrast: active){.ba-common-tabList__edge__wrapper{border:solid #fff}}.ba-common-tabList__edge__wrapper .ba-common-tabList__edge{width:16px}.ba-common-tabList__edge__wrapper.is-left{left:0;top:0;bottom:0;width:16px}.ba-common-tabList__edge__wrapper.is-right{right:0;top:0;bottom:0}.ba-common-tabList__edge__wrapper.is-top{top:0px}.ba-common-tabList__edge__wrapper.is-bottom{bottom:0px}.ba-common-tabList__edge__wrapper.is-visible{opacity:1;pointer-events:visible;display:block}.ba-common-tabList__inner{position:relative;white-space:nowrap;overflow-x:auto;overflow-y:hidden;padding-bottom:50px;display:flex}.ba-common-tabList__line{height:4px;border:0;border-bottom-width:4px;border-style:solid;position:absolute;left:0;bottom:0;margin:0}.ba-common-tabList__line.is-above{top:0px}.ba-common-tabList__line.is-hidden{display:none}.ba-common-tabList__list{margin:0;padding:0;position:relative;display:inline-block}.ba-common-tabList__list .is-dragging{opacity:0;z-index:auto !important;cursor:grab}.ba-common-tabList__itemDraggable{display:inline-block;vertical-align:middle}.ba-common-tabList__item{user-select:none;vertical-align:middle;display:inline-flex;align-content:center;justify-content:center;align-self:center;cursor:pointer;outline:0;height:40px;padding:0 8px;padding-right:24px;line-height:32px;position:relative;padding-left:16px;padding-right:16px;margin-left:0px;min-width:48px;max-width:300px;border:solid 2px transparent}.ba-common-tabList__item .ba-common-tabList__label__container{display:flex;flex-direction:row;flex-wrap:nowrap;justify-content:center}.ba-common-tabList__itemIcon{display:inline-block}.ba-common-tabList__item.is-label{min-width:48px}.ba-common-tabList__item.is-label .ba-common-tabList__labelIcon{order:2;margin-left:8px}.ba-common-tabList__item.is-label .ba-common-tabList__labelIcon.is-left-positioned-icon{order:0;margin-left:0px;margin-right:8px}.ba-common-tabList__item.is-label .ba-common-tabList__labelIcon.is-top-positioned-icon{margin:0 auto;order:0}.ba-common-tabList__item.is-label .ba-common-tabList__labelIcon.is-bottom-positioned-icon{margin:0 auto 4px}.ba-common-tabList__item.is-label.is-disabled{opacity:0.5;cursor:not-allowed;background-color:initial}.ba-common-tabList__item .ba-common-tabList__label{font-size:.875rem;font-weight:600;width:auto;text-overflow:ellipsis;overflow:hidden;line-height:normal;align-self:center;display:flex;flex-flow:row wrap}.ba-common-tabList__item .ba-common-tabList__labelText{order:1;text-overflow:ellipsis;white-space:nowrap;max-width:268px;outline:none}.ba-common-tabList__item .ba-common-tabList__labelText.is-top-positioned-icon,.ba-common-tabList__item .ba-common-tabList__labelText.is-bottom-positioned-icon{flex:1 0 100%}.ba-common-tabList .ba-common-tabList__labelIcon{align-self:center}.ba-common-tabList .ba-common-svgIcon.is-small.is-clickable.addNewIcon{top:calc(50% - 8px);margin:12px 12px 12px 12px;z-index:auto;right:0px;top:-8px;position:relative}.ba--highContrast .ba-common-tabList__edge{width:1px;border:0 solid transparent;border-left-width:1px;visibility:hidden}.ba--highContrast .ba-common-tabList__edge.is-visible{visibility:visible}.ba--highContrast .ba-common-tabList__line.is-under{border-style:double;border-bottom-width:2px}.ba-common-tabList__item.is-selected.is-editable .ba-common-tabList__labelText:focus{font-weight:normal;-webkit-user-select:text}.ba-common-tabList{transition:border-color .2s ease-in-out;border-color:#eaeaea}.ba-common-tabList__edge__wrapper{transition:opacity .2s ease-in-out;background-color:#fff;width:32px;z-index:100}.ba-common-tabList__edge__wrapper .chevron-icon{cursor:pointer;pointer-events:visible}.ba-common-tabList__edge__wrapper.is-left{width:32px}.ba-common-tabList__edge__wrapper.is-left .ba-common-tabList__edge{right:0px;position:absolute}.ba-common-tabList__edge__wrapper.is-left .chevron-icon{position:absolute;top:calc(50% - 8px);right:8px;transform:rotate(180deg)}.ba-common-tabList__edge__wrapper.is-top{height:32px;width:100%}.ba-common-tabList__edge__wrapper.is-top .ba-common-tabList__edge{background:linear-gradient(to bottom, rgba(52,51,52,0.2) 0%, rgba(0,0,0,0) 100%);bottom:0px;position:absolute;height:8px;width:100%}.ba-common-tabList__edge__wrapper.is-top .chevron-icon{position:absolute;top:0px;left:calc(50% - 8px);transform:rotate(270deg)}.ba-common-tabList__edge__wrapper.is-bottom{height:32px;width:100%}.ba-common-tabList__edge__wrapper.is-bottom .ba-common-tabList__edge{background:linear-gradient(to bottom, rgba(52,51,52,0.2) 0%, rgba(0,0,0,0) 100%);top:0px;position:absolute;height:8px;width:100%}.ba-common-tabList__edge__wrapper.is-bottom .chevron-icon{position:absolute;bottom:0px;left:calc(50% - 8px);transform:rotate(90deg)}.ba-common-tabList__edge__wrapper.is-right .ba-common-tabList__edge{right:0px}.ba-common-tabList__edge__wrapper.is-right .chevron-icon{position:absolute;top:calc(50% - 8px);left:8px}.ba-common-tabList__edge__wrapper .ba-common-tabList__edge{height:100%;width:8px}.ba-common-tabList__line{transition:left .2s ease-in-out,width .2s ease-in-out;border-color:#0f62fe}.ba-common-tabList__line.is-under{border-color:#8d8d8d}.ba-common-tabList__item{transition:color .2s ease-in-out;color:#343334}.ba-common-tabList__item.is-selected{color:#161616}[dir='rtl'] .ba-common-tabList__container.is-clicked .ba-common-tabList__list.line-position-right .ba-common-tabList__item:hover:not(.is-disabled){box-shadow:2px 0px 0 #8d8d8d inset;box-shadow:2px 0px 0 var(--ui-04, #8d8d8d) inset}[dir='rtl'] .ba-common-tabList__container.is-clicked .ba-common-tabList__list.line-position-right .ba-common-tabList__item[aria-selected=\"true\"]{box-shadow:2px 0px 0 #0f62fe inset;box-shadow:2px 0px 0 var(--interactive-01, #0f62fe) inset}[dir='rtl'] .ba-common-tabList__container.is-clicked .ba-common-tabList__list.line-position-right .ba-common-tabList__item[aria-selected=\"true\"]:hover .ba-common-tabList__itemIcon{left:4px}[dir='rtl'] .ba-common-tabList__list.line-position-right .ba-common-tabList__item:hover:not(.is-disabled){box-shadow:2px 0px 0 #8d8d8d inset;box-shadow:2px 0px 0 var(--ui-04, #8d8d8d) inset}[dir='rtl'] .ba-common-tabList__list.line-position-right .ba-common-tabList__item[aria-selected=\"true\"]{box-shadow:2px 0px 0 #0f62fe inset;box-shadow:2px 0px 0 var(--interactive-01, #0f62fe) inset}@media screen and (-ms-high-contrast: active){[dir='rtl'] .ba-common-tabList__list.line-position-right .ba-common-tabList__item[aria-selected=\"true\"]{border:solid #fff}}[dir='rtl'] .ba-common-tabList__list.line-position-right .ba-common-tabList__item[aria-selected=\"true\"]:focus{box-shadow:2px 0px 0 #0f62fe inset,inset 0px 0px 0px 2px #0f62fe;box-shadow:2px 0px 0 var(--interactive-01, #0f62fe) inset,inset 0px 0px 0px 2px var(--focus, #0f62fe)}[dir='rtl'] .ba-common-tabList__list.line-position-right .ba-common-tabList__item[aria-selected=\"true\"]:hover .ba-common-tabList__itemIcon{left:4px;right:auto}[dir='rtl'] .ba-common-tabList .ba-common-tabList__item:hover .ba-common-tabList__itemIcon{left:0;right:auto}[dir='rtl'] .ba-common-tabList__item[aria-selected=\"true\"]:hover .ba-common-tabList__itemIcon{left:4px}[dir='rtl'] .ba-common-tabList.is-addable .ba-common-tabList__edge__wrapper.is-left{left:0px}[dir='rtl'] .ba-common-tabList.is-addable .ba-common-tabList__edge__wrapper.is-right{right:0px}.ba-common-tabList.is-tabButton{border-bottom-width:0px}.ba-common-tabList.is-tabButton.is-deleteable .ba-common-tabList__item{border:none}.ba-common-tabList.is-tabButton.is-deleteable .ba-common-tabList__item:hover .ba-common-tabList__itemIcon{display:inline-flex;position:absolute;height:100%;width:24px;top:0;background-color:transparent}[dir=\"ltr\"].ba-common-tabList.is-tabButton.is-deleteable .ba-common-tabList__item:hover .ba-common-tabList__itemIcon{right:0;margin-right:2px}[dir=\"rtl\"].ba-common-tabList.is-tabButton.is-deleteable .ba-common-tabList__item:hover .ba-common-tabList__itemIcon{right:auto;left:0;margin-right:0;margin-left:2px}[dir=\"ltr\"] .ba-common-tabList.is-tabButton.is-deleteable .ba-common-tabList__item:hover .ba-common-tabList__itemIcon,.ba-common-tabList.is-tabButton.is-deleteable .ba-common-tabList__item:hover .ba-common-tabList__itemIcon{right:0;margin-right:2px}[dir=\"rtl\"] .ba-common-tabList.is-tabButton.is-deleteable .ba-common-tabList__item:hover .ba-common-tabList__itemIcon{right:auto;left:0;margin-right:0;margin-left:2px}.ba-common-tabList.is-tabButton.is-deleteable .ba-common-tabList__itemIcon .ba-common-svgIcon{fill:#fff;color:#fff;position:absolute;top:calc(50% - 8px);left:calc(50% - 8px)}.ba-common-tabList.is-tabButton.is-deleteable .ba-common-tabList__item[aria-selected=\"true\"]{padding-right:0px}@media screen and (-ms-high-contrast: active){.ba-common-tabList.is-tabButton.is-deleteable .ba-common-tabList__item[aria-selected=\"true\"]{background-color:#fff;color:#000}}@media screen and (-ms-high-contrast: active){.ba-common-tabList.is-tabButton.is-deleteable .ba-common-tabList__item[aria-selected=\"true\"] .ba-common-tabList__itemIcon .ba-common-svgIcon{fill:#000}}[dir=\"ltr\"].ba-common-tabList.is-tabButton.is-deleteable .ba-common-tabList__item[aria-selected=\"true\"]{padding-left:26px}[dir=\"rtl\"].ba-common-tabList.is-tabButton.is-deleteable .ba-common-tabList__item[aria-selected=\"true\"]{padding-left:0;padding-right:26px}[dir=\"ltr\"] .ba-common-tabList.is-tabButton.is-deleteable .ba-common-tabList__item[aria-selected=\"true\"],.ba-common-tabList.is-tabButton.is-deleteable .ba-common-tabList__item[aria-selected=\"true\"]{padding-left:26px}[dir=\"rtl\"] .ba-common-tabList.is-tabButton.is-deleteable .ba-common-tabList__item[aria-selected=\"true\"]{padding-left:0;padding-right:26px}.ba-common-tabList.is-tabButton.is-deleteable .ba-common-tabList__item[aria-selected=\"true\"]:hover .ba-common-tabList__itemIcon{height:100%}[dir=\"ltr\"].ba-common-tabList.is-tabButton.is-deleteable .ba-common-tabList__item[aria-selected=\"true\"]:hover .ba-common-tabList__itemIcon{margin-right:2px}[dir=\"rtl\"].ba-common-tabList.is-tabButton.is-deleteable .ba-common-tabList__item[aria-selected=\"true\"]:hover .ba-common-tabList__itemIcon{margin-right:0;margin-left:2px}[dir=\"ltr\"] .ba-common-tabList.is-tabButton.is-deleteable .ba-common-tabList__item[aria-selected=\"true\"]:hover .ba-common-tabList__itemIcon,.ba-common-tabList.is-tabButton.is-deleteable .ba-common-tabList__item[aria-selected=\"true\"]:hover .ba-common-tabList__itemIcon{margin-right:2px}[dir=\"rtl\"] .ba-common-tabList.is-tabButton.is-deleteable .ba-common-tabList__item[aria-selected=\"true\"]:hover .ba-common-tabList__itemIcon{margin-right:0;margin-left:2px}.ba-common-tabList.is-tabButton.is-deleteable .ba-common-tabList__item[aria-selected=\"true\"]:hover .ba-common-tabList__itemIcon .ba-common-svgIcon{top:calc(50% - 8px);left:calc(50% - 8px)}.ba-common-tabList.is-tabButton.is-deleteable .ba-common-tabList__item[aria-selected=\"true\"] .ba-common-tabList__itemIcon{display:inline-flex;position:relative;height:100%;width:24px;top:0;background-color:transparent}[dir=\"ltr\"].ba-common-tabList.is-tabButton.is-deleteable .ba-common-tabList__item[aria-selected=\"true\"] .ba-common-tabList__itemIcon{margin-right:2px;right:0}[dir=\"rtl\"].ba-common-tabList.is-tabButton.is-deleteable .ba-common-tabList__item[aria-selected=\"true\"] .ba-common-tabList__itemIcon{margin-right:0;margin-left:2px;right:auto;left:0}[dir=\"ltr\"] .ba-common-tabList.is-tabButton.is-deleteable .ba-common-tabList__item[aria-selected=\"true\"] .ba-common-tabList__itemIcon,.ba-common-tabList.is-tabButton.is-deleteable .ba-common-tabList__item[aria-selected=\"true\"] .ba-common-tabList__itemIcon{margin-right:2px;right:0}[dir=\"rtl\"] .ba-common-tabList.is-tabButton.is-deleteable .ba-common-tabList__item[aria-selected=\"true\"] .ba-common-tabList__itemIcon{margin-right:0;margin-left:2px;right:auto;left:0}.ba-common-tabList.is-tabButton .ba-common-tabList__item{border:none;box-shadow:0 0 0 2px #0f62fe inset;box-shadow:0 0 0 2px var(--interactive-01, #0f62fe) inset;padding-left:26px;padding-right:26px;color:#0f62fe;transition:none}.ba-common-tabList.is-tabButton .ba-common-tabList__item .ba-common-tabList__labelText:focus{color:inherit}[dir=\"ltr\"].ba-common-tabList.is-tabButton .ba-common-tabList__item{margin-right:8px}[dir=\"rtl\"].ba-common-tabList.is-tabButton .ba-common-tabList__item{margin-right:0;margin-left:8px}[dir=\"ltr\"] .ba-common-tabList.is-tabButton .ba-common-tabList__item,.ba-common-tabList.is-tabButton .ba-common-tabList__item{margin-right:8px}[dir=\"rtl\"] .ba-common-tabList.is-tabButton .ba-common-tabList__item{margin-right:0;margin-left:8px}@media screen and (-ms-high-contrast: active){.ba-common-tabList.is-tabButton .ba-common-tabList__item{box-shadow:inset 0px 0px 0px 2px #fff}}.ba-common-tabList.is-tabButton .ba-common-tabList__item:hover{color:#fff;background-color:#0f62fe}.ba-common-tabList.is-tabButton .ba-common-tabList__item[aria-selected=\"true\"]{color:#fff;background-color:#002d9c}@media screen and (-ms-high-contrast: active){.ba-common-tabList.is-tabButton .ba-common-tabList__item[aria-selected=\"true\"]{background-color:#fff;color:#000}}\n", ""]);

// exports
exports.locals = {
	"tabListClassName": "\"ba-common-tabList\""
};

/***/ }),

/***/ 507:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

var _interopRequireWildcard = __webpack_require__(2);

exports.__esModule = true;
exports["default"] = exports.TabScrollButtonDnd = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(7));

var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(11));

var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(8));

var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(5));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(6));

var _react = _interopRequireWildcard(__webpack_require__(1));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _utils = __webpack_require__(4);

var _svgicon = _interopRequireDefault(__webpack_require__(13));

var _reactDnd = __webpack_require__(26);

var _chevronRight_ = _interopRequireDefault(__webpack_require__(83));

var _ItemTypes = _interopRequireDefault(__webpack_require__(123));

__webpack_require__(56);

var _dec, _class, _class2, _temp;

var dropTarget = {};

function collect(connect, monitor) {
  return {
    connectDropTarget: connect.dropTarget(),
    isOver: monitor.isOver()
  };
}

var TabScrollButtonDnd = (_dec = (0, _reactDnd.DropTarget)(_ItemTypes["default"].TAB, dropTarget, collect), _dec(_class = (_temp = _class2 = /*#__PURE__*/function (_Component) {
  (0, _inheritsLoose2["default"])(TabScrollButtonDnd, _Component);

  function TabScrollButtonDnd() {
    return _Component.apply(this, arguments) || this;
  }

  var _proto = TabScrollButtonDnd.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        connectDropTarget = _this$props.connectDropTarget,
        other = (0, _objectWithoutPropertiesLoose2["default"])(_this$props, ["connectDropTarget"]);
    return connectDropTarget( /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(TabScrollButton, other)));
  };

  return TabScrollButtonDnd;
}(_react.Component), (0, _defineProperty2["default"])(_class2, "propTypes", {
  connectDropTarget: _propTypes["default"].func.isRequired
}), _temp)) || _class);
exports.TabScrollButtonDnd = TabScrollButtonDnd;

var TabScrollButton = /*#__PURE__*/function (_Component2) {
  (0, _inheritsLoose2["default"])(TabScrollButton, _Component2);

  function TabScrollButton(props) {
    var _this;

    _this = _Component2.call(this, props) || this;
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "themeHoverOn", function () {
      _this.setState({
        themeHover: true
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "themeHoverOff", function () {
      _this.setState({
        themeHover: false
      });
    });
    _this.state = {
      scrollIntervalId: null,
      themeHover: false
    };
    return _this;
  }

  var _proto2 = TabScrollButton.prototype;

  _proto2.componentDidUpdate = function componentDidUpdate(prevProps) {
    var _this2 = this;

    // check when the hover state has been entered or exited
    if (prevProps.isOver !== this.props.isOver) {
      if (this.props.isOver === true) {
        this.setState({
          scrollIntervalId: setInterval(function () {
            _this2.props.scrollHandler();
          }, 1000)
        });
      } else {
        clearInterval(this.state.scrollIntervalId);
      }
    }
  };

  _proto2.configureAndGetWrapperStyling = function configureAndGetWrapperStyling() {
    var _this$props2 = this.props,
        backgroundColor = _this$props2.backgroundColor,
        textColor = _this$props2.textColor,
        hoverColor = _this$props2.hoverColor;
    var themeBackgroundColor = this.state.themeHover && hoverColor ? hoverColor : backgroundColor;
    var shadowStyle = this.getShadowStyle();
    var style = (0, _extends2["default"])({}, backgroundColor || hoverColor ? {
      backgroundColor: themeBackgroundColor
    } : {}, textColor ? {
      color: this.props.textColor
    } : {}, shadowStyle);
    return style;
  };

  _proto2.getShadowStyle = function getShadowStyle() {
    var _this$props3 = this.props,
        left = _this$props3.left,
        right = _this$props3.right,
        _this$props3$textColo = _this$props3.textColor,
        textColor = _this$props3$textColo === void 0 ? 'black' : _this$props3$textColo;
    var style;

    if (left) {
      style = {
        boxShadow: "-6px 0px 12px 2px " + textColor
      };
    } else if (right) {
      style = {
        boxShadow: "-6px 0px 12px -8px " + textColor
      };
    }

    return style;
  };

  _proto2.render = function render() {
    var _this$props4 = this.props,
        bottom = _this$props4.bottom,
        top = _this$props4.top,
        left = _this$props4.left,
        right = _this$props4.right,
        onClick = _this$props4.onClick,
        scrolling = _this$props4.scrolling;
    var wrapperStyle = this.configureAndGetWrapperStyling();
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: (0, _utils.classnames)('ba-common-tabList__edge__wrapper', {
        visible: scrolling
      }, {
        bottom: bottom
      }, {
        top: top
      }, {
        left: left
      }, {
        right: right
      }),
      onClick: onClick,
      onMouseEnter: this.themeHoverOn,
      onMouseLeave: this.themeHoverOff,
      style: wrapperStyle
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: (0, _utils.classnames)('ba-common-tabList__edge')
    }), /*#__PURE__*/_react["default"].createElement(_svgicon["default"], {
      className: "chevron-icon",
      iconId: _chevronRight_["default"].id
    }));
  };

  return TabScrollButton;
}(_react.Component);

exports["default"] = TabScrollButton;
(0, _defineProperty2["default"])(TabScrollButton, "propTypes", {
  scrolling: _propTypes["default"].bool,
  onClick: _propTypes["default"].func,
  bottom: _propTypes["default"].bool,
  top: _propTypes["default"].bool,
  right: _propTypes["default"].bool,
  left: _propTypes["default"].bool,
  scrollHandler: _propTypes["default"].func.isRequired,
  isOver: _propTypes["default"].bool,
  backgroundColor: _propTypes["default"].string,
  textColor: _propTypes["default"].string,
  hoverColor: _propTypes["default"].string
});

/***/ }),

/***/ 508:
/***/ (function(module, exports) {

var amdi18n={"__root":{"addNewTab":"Add new tab","newContent":"Content for tab"},"__cs":{"addNewTab":"Přidat novou kartu","newContent":"Obsah karty"},"__da":{"addNewTab":"Tilføj et nyt skilleblad","newContent":"Indhold til skilleblad"},"__de":{"addNewTab":"Neue Registerkarte hinzufügen","newContent":"Inhalt der Registerkarte"},"__es":{"addNewTab":"Añadir nueva pestaña","newContent":"Contenido para pestaña"},"__fi":{"addNewTab":"Lisää uusi välilehti","newContent":"Välilehden sisältö"},"__fr":{"addNewTab":"Ajouter un nouvel onglet","newContent":"Contenu de l'onglet"},"__hr":{"addNewTab":"Dodaj novu karticu","newContent":"Sadržaj za karticu"},"__hu":{"addNewTab":"Új lap hozzáadása","newContent":"Lap tartalma"},"__it":{"addNewTab":"Aggiungi nuova scheda","newContent":"Contenuto per la scheda"},"__ja":{"addNewTab":"新規タブの追加","newContent":"タブのコンテンツ"},"__kk":{"addNewTab":"Жаңа қойындыны қосу","newContent":"Қойындыға арналған мазмұн"},"__ko":{"addNewTab":"새 탭 추가","newContent":"탭에 대한 컨텐츠"},"__nb":{"addNewTab":"Legg til ny flipp","newContent":"Innhold for flipp"},"__nl":{"addNewTab":"Nieuw tabblad toevoegen","newContent":"Inhoud voor tabblad"},"__no":{"addNewTab":"Legg til ny flipp","newContent":"Innhold for flipp"},"__pl":{"addNewTab":"Dodaj nową kartę","newContent":"Zawartość karty"},"__pt":{"addNewTab":"Incluir nova guia","newContent":"Conteúdo para guia"},"__pt-br":{"addNewTab":"Incluir nova guia","newContent":"Conteúdo para guia"},"__ro":{"addNewTab":"Adăugare filă nouă","newContent":"Conţinut pentru filă"},"__ru":{"addNewTab":"Добавить новую вкладку","newContent":"Содержимое для вкладки"},"__sl":{"addNewTab":"Dodaj nov zavihek","newContent":"Vsebina za zavihek"},"__sv":{"addNewTab":"Lägg till ny flik","newContent":"Innehåll för flik"},"__th":{"addNewTab":"เพิ่มแท็บใหม่","newContent":"เนื้อหาสำหรับแท็บ"},"__tr":{"addNewTab":"Yeni sekme ekle","newContent":"Sekme içeriği"},"__zh":{"addNewTab":"添加新选项卡","newContent":"选项卡的内容"},"__zh-cn":{"addNewTab":"添加新选项卡","newContent":"选项卡的内容"},"__zh-hk":{"addNewTab":"新增標籤","newContent":"標籤的內容"},"__zh-mo":{"addNewTab":"新增標籤","newContent":"標籤的內容"},"__zh-sg":{"addNewTab":"添加新选项卡","newContent":"选项卡的内容"},"__zh-tw":{"addNewTab":"新增標籤","newContent":"標籤的內容"}};amdi18n.init=function (language){
		// get the default language
		if(!language){
			if(window._i18n && window._i18n.locale){
				language = window._i18n.locale;
			}else if(document.documentElement.lang){
				language = document.documentElement.lang;
			}else{
				language = 'root';
			}
		}
		var target = this['__' + language] || this.__root;

		// copy definition to root level
		if (target) {
			for (var name in target) {
				this[name] = target[name];
			}
		}

		// fallback to root
		for(var name in this.__root){
			if(typeof this[name] === 'undefined'){
				this[name] = this.__root[name];
			}
		}
	};amdi18n.init();module.exports=amdi18n;

/***/ }),

/***/ 56:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(506);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"modules":true,"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(10)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {}

/***/ }),

/***/ 6:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/defineProperty");

/***/ }),

/***/ 7:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/extends");

/***/ }),

/***/ 72:
/***/ (function(module, exports) {

module.exports = require("@ba/ba-graphics/dist/icons-js/add_32");

/***/ }),

/***/ 8:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/objectWithoutPropertiesLoose");

/***/ }),

/***/ 83:
/***/ (function(module, exports) {

module.exports = require("@ba/ba-graphics/dist/icons-js/chevron-right_16.js");

/***/ }),

/***/ 88:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__88__;

/***/ }),

/***/ 9:
/***/ (function(module, exports) {

module.exports = require("css-loader/lib/css-base");

/***/ })

},[[501,0]]]);
});